import { Button, DataTable, Icon, Modal, TextArea } from "pepsico-ds";
import React, { useState, useRef, useEffect, useCallback } from "react";
import "./workflow.css";
import AgGridComponent from "../../common/ag_grid";
import { useNavigate } from "react-router-dom";
import workflowService from "./workflowservice";
import ActionCellRender from "./actionCellRender";
import { useLoading } from "../../loader";
import { toast,ToastContainer } from 'react-toastify';
import CustomCellRender from "./customCellRender";
import { Tooltip } from 'react-tooltip'; // ✅ Correct way in v5+
import 'react-tooltip/dist/react-tooltip.css'; // Include styles
import CustomTooltipCellRenderer from "../../common/custom_grid_tooltip";
import { useOktaAuth } from "@okta/okta-react";
import { useTranslation } from "react-i18next";
import NoDataFound from "../../common/no_data_found";
import axios from "axios";
import { resolveApplicationName } from "../../utils/resolveApplicationName";

const PendingApprovals_Old = ({
  rowData,
  dateRange,
  searchTerm,
  debouncedSearchTerm,
  changedValue,
  filterString,
  gridToCard,
  shouldFetch,
  displayType,
  onDataFromPendingApprovals,
  setLoading,
  onResetFetch,
  onResetSearch,
  onShowErrorPage,
  refresh,
  roles,
  selectedApprovalTabIndex,
  resetFilters,
  handleSearch,
  reFetchAfterClear,
  setReFetchAfterClear,
  isEntraApproval,
  setFetchAfterTabChange,
  fetchAfterTabChange,
  isMyPamApproval,
  isSSOApproval,
  isRetirementApproval
}) => {
   const { oktaAuth } = useOktaAuth();
  const containerRef = useRef(null);
  const innerContainerRef = useRef(null);
  const lastScrollTopRef = useRef(0);
  let [displayedItems, setDisplayedItems] = useState(null);
  const [pages, setPages] = useState([1]);
  const [hasNextPage, setHasNextPage] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isTab, setIsTab] = useState(
    window.innerWidth > 768 && window.innerWidth <= 1024
  );
  const { REACT_APP_API_ENDPOINT } = process.env;
  const itemsPerPage = 8;
  const [toasts, setToasts] = useState([]);
  const [allItems, setAllItems] = useState([]);
  const userData = JSON.parse(localStorage.getItem("okta-token-storage"));
  const [currentPage, setCurrentPage] = useState(0);
  const [approvalData, setApprovalData] = useState([]);
  const [viewReqestData, setViewRequestData] = useState("");
  const [myPamViewMoreData, setMyPamViewMoreData] = useState("");
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [shouldReFetch, setShouldReFetch] = useState(false);
  const agGridRef = useRef();
  const navigate = useNavigate();
  const { t,i18n } = useTranslation();
  const { showLoader, hideLoader } = useLoading();
  const [isEntraViewModalOpen, setIsEntraViewModalOpen] = useState(false)
  const [isRetirementViewModalOpen, setIsRetirementViewModalOpen] = useState(false)
  const [retirementViewMoreData, setRetirementViewMoreData] = useState("");
  const [isMyPamViewModalOpen, setIsMyPamViewModalOpen] = useState(false)
  const [isSSOViewModalOpen, setIsSSOViewModalOpen] = useState(false)
  const [ssoViewMoreData, setSSOViewMoreData] = useState({})
  // SSO attachment states
  const [ssoLogoUrl, setSsoLogoUrl] = useState(null);
  const [ssoCertificateUrl, setSsoCertificateUrl] = useState(null);
  const [ssoCertificateName, setSsoCertificateName] = useState(null);
  const [isSSOLogoPreviewOpen, setIsSSOLogoPreviewOpen] = useState(false);
  const [ssoLogoPreviewSrc, setSsoLogoPreviewSrc] = useState(null);

  useEffect(()=>{
    const makeContainerCenter = () => {
      const cardContainer = document.querySelector(".cards-container");
      const approvalCard = document.querySelector(".card.approvalCard");
      if(cardContainer && approvalCard){
        const cardContainerWidth = cardContainer?.offsetWidth || cardContainer?.clientWidth;
        const approvalCardWidth = approvalCard?.offsetWidth || approvalCard?.clientWidth;
        const paddingRequire = ((cardContainerWidth+12) % (approvalCardWidth+12))/2;
        cardContainer.style.paddingLeft = `${paddingRequire}px`;
        cardContainer.style.paddingRight = `${paddingRequire}px`;
      }
    }
    makeContainerCenter();
    window.addEventListener("resize", makeContainerCenter);
    return () => {
      window.removeEventListener("resize", makeContainerCenter);
    };
  },[displayedItems]);

  const openSSOLogoPreview = (logoSrc) => {
    if (!logoSrc) return;
    setSsoLogoPreviewSrc(logoSrc);
    setIsSSOLogoPreviewOpen(true);
  };

  const closeSSOLogoPreview = () => {
    setIsSSOLogoPreviewOpen(false);
    setSsoLogoPreviewSrc(null);
  };
  const guestUsersDetailsColumns = [
      { columnKey: "guestName", header: t("entraGuest.table_guest_name"), showColumnVisibility: true, initialSize: 120 },
      { columnKey: "guestEmail", header: t("entraGuest.table_guest_email"), showColumnVisibility: true, initialSize: 120 },
    ];

  function camelToTitle(str) {
      return str
          .split(/(?=[A-Z])/) // split before uppercase letters
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
  }

  function formatMyPAMRequestType(str) {
    str = str.slice("MYPAM_".length);
    return str
      .split("_")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }
  useEffect(()=>{
    if(shouldReFetch){
      loadMoreItems(true);
      setShouldReFetch(false);
    }else{
      const inputClearIcon = document.querySelector(".approvals-search .search-clearable-icon");
      const inputEle = document.querySelector(".approvals-search input");
      inputClearIcon?.click?.();
      inputEle?.blur?.();
    }
  },[shouldReFetch])

  useEffect(()=>{
    if(reFetchAfterClear || fetchAfterTabChange){
      if(fetchAfterTabChange){
        setDisplayedItems([]);
        setFetchAfterTabChange(false);
      }
      setReFetchAfterClear(false);
      loadMoreItems(true);
    }

  },[reFetchAfterClear, fetchAfterTabChange]);

  // Fetch SSO attachments (logo and certificate)
  const fetchSSOAttachments = async (requestNumber, ssoData) => {
    // Reset previous values
    setSsoLogoUrl(null);
    setSsoCertificateUrl(null);
    setSsoCertificateName(null);

    // Fetch logo if hasLogo is true (check multiple possible field names)
    const hasLogo = ssoData?.['hasLogo'] === 'true' || ssoData?.['hasLogo'] === true || 
                    ssoData?.hasLogo === 'true' || ssoData?.hasLogo === true ||
                    ssoData?.['Has Logo'] === 'true' || ssoData?.['Has Logo'] === 'Yes';
    if (hasLogo) {
      try {
        const response = await axios.get(
          `${REACT_APP_API_ENDPOINT}sso/attachments/${requestNumber}/LOGO`,
          { responseType: 'blob' }
        );
        if (response?.data) {
          const blob = new Blob([response.data], { type: response.headers['content-type'] || 'image/png' });
          const url = URL.createObjectURL(blob);
          setSsoLogoUrl(url);
        }
      } catch (error) {
        console.error('Error fetching SSO logo:', error);
      }
    }

    // Fetch certificate if hasCertificate is true (check multiple possible field names)
    const hasCertificate = ssoData?.['hasCertificate'] === 'true' || ssoData?.['hasCertificate'] === true ||
                           ssoData?.hasCertificate === 'true' || ssoData?.hasCertificate === true ||
                           ssoData?.['Has Certificate'] === 'true' || ssoData?.['Has Certificate'] === 'Yes';
    if (hasCertificate) {
      try {
        const response = await axios.get(
          `${REACT_APP_API_ENDPOINT}sso/attachments/${requestNumber}/CERTIFICATE`,
          { responseType: 'blob' }
        );
        if (response?.data) {
          const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/x-x509-ca-cert' });
          const url = URL.createObjectURL(blob);
          setSsoCertificateUrl(url);
          // Extract filename from content-disposition header if available
          const contentDisposition = response.headers['content-disposition'];
          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (filenameMatch && filenameMatch[1]) {
              setSsoCertificateName(filenameMatch[1].replace(/['"]/g, ''));
            }
          }
        }
      } catch (error) {
        console.error('Error fetching SSO certificate:', error);
      }
    }
  };

  const hasSsoLogoData = !!(
    ssoLogoUrl ||
    ssoViewMoreData?.logoUrl ||
    ssoViewMoreData?.logoFileName ||
    ssoViewMoreData?.['logoFileName'] ||
    ssoViewMoreData?.['Logo File Name']
  );

  const hasSsoCertificateData = !!(
    ssoCertificateUrl ||
    ssoCertificateName ||
    ssoViewMoreData?.['certificateFileName'] ||
    ssoViewMoreData?.certificateFileName ||
    ssoViewMoreData?.['Certificate File Name']
  );

  const downloadBulkfile = async(requestNumber, fileName) => {
    try {
        const response = await axios.get(REACT_APP_API_ENDPOINT + `entra/downloadBulkCsv?requestNumber=${requestNumber}`, {
            responseType: "blob",
        });

        const blob = new Blob([response.data], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        toast.error("Something went wrong", "error");
        console.error("Error downloading the file:", error);
    }
  }

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setIsTab(window.innerWidth > 768 && window.innerWidth <= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const showToast = (message, type) => {
    setToasts([
      {
        id: 1,
        duration: 100000,
        text: message,
        type: type,
        position: "bottom-right",
      },
    ]);
  };

  const removeToast = (id) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  };

  const [isGridType, setIsGridType] = React.useState(true);
  const [filteredItems, setFilteredItems] = useState([]);
  const filteredItemsRef = useRef(null);
  const openModal = useCallback((type, requestData, selectionType) => {
    setApprovalData([]);
    let preparedData = [];
    if (selectionType === 'single') {
      preparedData = [{
        type,
        workItemId: !["", null, undefined, "null", "undefined"].includes(requestData?.workItemId?.trim?.()) ? requestData?.workItemId : requestData?.workItemId || "",
        enableRedirection: !["", null, undefined, "null", "undefined"].includes(requestData?.enableRedirection) ? requestData?.enableRedirection : requestData?.enableRedirection || false,
        requestNumber: !["", null, undefined, "null", "undefined"].includes(requestData?.requestNumber?.trim?.()) ? requestData?.requestNumber : requestData?.requestNumber || "",
        requestedFor: !["", null, undefined, "null", "undefined"].includes(requestData?.requestedFor?.trim?.()) ? requestData?.requestedFor : requestData?.requestedFor || "",
        requestedBy: !["", null, undefined, "null", "undefined"].includes(requestData?.requestedBy?.trim?.()) ? requestData?.requestedBy : requestData?.requestedBy || "",
        applicationName: !["", null, undefined, "null", "undefined"].includes(requestData?.applicationName?.trim?.()) ? requestData?.applicationName : requestData?.applicationName || "",
        applicationDesc: !["", null, undefined, "null", "undefined"].includes(requestData?.applicationDesc?.trim?.()) ? requestData?.applicationDesc : requestData?.applicationDesc || "",
        delegatedFrom: !["", null, undefined, "null", "undefined"].includes(requestData?.delegatedFrom?.trim?.()) ? requestData?.delegatedFrom : requestData?.delegatedFrom || "",
        ...(isEntraApproval && {requestType: !["", null, undefined, "null", "undefined"].includes(requestData?.requestType?.trim?.()) ? requestData?.requestType : requestData?.requestType || ""}),
        ...(isRetirementApproval && {taskId: !["", null, undefined, "null", "undefined"].includes(requestData?.taskId?.trim?.()) ? requestData?.taskId : requestData?.taskId || ""})
      }];
    } else if (selectionType === 'multiple') {
      preparedData = requestData.map(item => ({
        type,
        workItemId: !["", null, undefined, "null", "undefined"].includes(item?.workItemId?.trim?.()) ? item?.workItemId : requestData?.workItemId || "",
        enableRedirection: !["", null, undefined, "null", "undefined"].includes(item?.enableRedirection?.trim?.()) ? item?.enableRedirection : requestData?.enableRedirection || false,
        requestNumber: !["", null, undefined, "null", "undefined"].includes(item?.requestNumber?.trim?.()) ? item?.requestNumber : item?.requestNumber || "",
        requestedFor: !["", null, undefined, "null", "undefined"].includes(item?.requestedFor?.trim?.()) ? item?.requestedFor : item?.requestedFor || "",
        requestedBy: !["", null, undefined, "null", "undefined"].includes(item?.requestedBy?.trim?.()) ? item?.requestedBy : item?.requestedBy || "",
        applicationName: !["", null, undefined, "null", "undefined"].includes(item?.applicationName?.trim?.()) ? item?.applicationName : item?.applicationName || "",
        applicationDesc: !["", null, undefined, "null", "undefined"].includes(item?.applicationDesc?.trim?.()) ? item?.applicationDesc : item?.applicationDesc || "",
        delegatedFrom: !["", null, undefined, "null", "undefined"].includes(item?.delegatedFrom?.trim?.()) ? item?.delegatedFrom : item?.delegatedFrom || "",
        ...(isEntraApproval && {requestType: !["", null, undefined, "null", "undefined"].includes(item?.requestType?.trim?.()) ? item?.requestType : item?.requestType || ""}),
        ...(isRetirementApproval && {taskId: !["", null, undefined, "null", "undefined"].includes(requestData?.taskId?.trim?.()) ? requestData?.taskId : requestData?.taskId || ""})
      }));

    }
    setApprovalData(preparedData);
    console.log("Approval Data:", approvalData);
    // if (roles?.includes("isApprovals")) {
    if (requestData?.enableRedirection) {
      const w = window.screen.width * .9;
      const h = window.screen.height * .9;
      const l = window.screen.width * .05;
      const t = window.screen.height * .05;
      window.open(requestData?.viewWorkItemUrl, "_blank", `width=${w},height=${h},left=${l},top=${t}`);
    } else {
      if (type === 'Approve') {
        isRetirementApproval ? approveOrRejectAppRetirement(type, preparedData) : isSSOApproval ? approveOrRejectSSORequest(type, preparedData) : isEntraApproval ? approveOrRejectEntraRequest(type, preparedData) : isMyPamApproval ? approveOrRejectMyPamRequest(type, preparedData) : approveOrRejectRequest(type, preparedData);
      }
      else {
        setIsModalOpen(true);
      }
    }
    // } else {
    //   approveOrRejectRequest(type, preparedData);
    // }
  });
  const closeModal = () => setIsModalOpen(false);

  const openEntraViewModal = useCallback(async(type, card)=>{
    if(card?.requestType === 'INLINE' && !card?.viewRequestDetails?.bulkRequestDetails){
      try {
        showLoader();
        const payload = {
          requestNumber: card?.requestNumber,
          requestType: "INLINE"
        }
        const response = await workflowService.entraViewRequestDetails(payload);
        setViewRequestData({ ...response, requestType: card?.requestType, requestNumber: card?.requestNumber, requestedBy: card?.requestedBy, requestedByUserName: card?.requesterName });
        setIsEntraViewModalOpen(true);
      }catch(error){
        toast.error("Something went wrong. Please contact Support for assistance.", "error");
      }finally{
        hideLoader();
      }
    }else if(card?.requestType === 'Entra App Registration'){
      try {
        showLoader();
        const response = await workflowService.appRegistrationViewRequestDetails(card?.requestNumber);
        setViewRequestData({ ...response, requestType: card?.requestType, requestNumber: card?.requestNumber, requestedBy: card?.requestedBy, requestedByUserName: card?.requesterName });
        setIsEntraViewModalOpen(true);
      }catch(error){
        toast.error("Something went wrong. Please contact Support for assistance.", "error");
      }finally{
        hideLoader();
      }
    }else{
      setViewRequestData({requestType: card?.requestType, requestNumber: card?.requestNumber, requestedBy: card?.requestedBy, requestedByUserName: card?.requesterName,  ...card?.viewRequestDetails?.bulkRequestDetails});
      setIsEntraViewModalOpen(true);
    }
  },[])

  const openMyPamViewModal = useCallback(async(type, card)=>{
      setViewRequestData({...card});
      const {requestType, createdAt, requesterGpid, requestedForGpid, approverGpid, requesterName, requestedForName, timestamp, requestedBy, requestedFor, requestedByUserName, userName, ...viewMoreData} = card;
      setMyPamViewMoreData(viewMoreData);
      setIsMyPamViewModalOpen(true);
  },[])

  const openRetirementViewModal = useCallback(async(type, card)=>{
      setViewRequestData({...card});
      const {requestType, createdAt, requesterGpid, requestedForGpid, requesterName, requestedForName, timestamp, requestedBy, requestedFor, requestedByUserName, userName, ...viewMoreData} = card;
      setRetirementViewMoreData(viewMoreData);
      setIsRetirementViewModalOpen(true);
  },[])

  // Shared resolver is defined in src/utils/resolveApplicationName.js.

  const openSSOViewModal = useCallback(async(type, card)=>{
      setViewRequestData({...card});
      // Merge displayFields, rawRequest.request, and attachments for complete data
      const displayFields = card?.requestDetails?.displayFields || card?.displayFields || {};
      const rawRequest = card?.requestDetails?.rawRequest?.request || card?.rawRequest?.request || {};
      const attachments = card?.requestDetails?.attachments || card?.attachments || {};
      const tokenValidation = card?.requestDetails?.tokenValidation || card?.tokenValidation || null;
      // Some requests (e.g. SSO modifications) return basic fields directly on the
      // top-level card/item instead of nesting them under requestDetails.displayFields.
      // Fall back to those so details aren't blank for those request types.
      const cardLevelFallback = {
        'Integration Type': card?.integrationType,
        'Sector': card?.sector,
        'Environment': card?.environment,
        'Business Application': card?.businessApplication || card?.businessAppName,
        'Application Service': card?.applicationService,
        'Data Classification': card?.dataClassification,
        'Application Owner': card?.applicationOwner,
        'Application Name': resolveApplicationName(card),
      };
      const viewMoreData = {
        ...cardLevelFallback,
        ...displayFields,
        ...rawRequest,
        ...attachments,
        tokenValidation,
        // Ensure type is available
        type: card?.requestDetails?.rawRequest?.type || card?.applicationType || displayFields?.['Integration Type'],
      };
      console.log('SSO View More Data:', viewMoreData);
      setSSOViewMoreData(viewMoreData);
      setIsSSOViewModalOpen(true);
      // Fetch SSO attachments (logo and certificate)
      if (card?.requestNumber) {
        fetchSSOAttachments(card.requestNumber, viewMoreData);
      }
  },[])

  const openViewModal = useCallback(async(type, requestData) => {
    // requestData.businessDetailsParams.push({
    //   detailsKey: 'Suggested Entitlements', displayOrder: requestData.businessDetailsParams.length + 1, detailsValue: '<br><font size=1><b>(Describe database privileges/roles like SELECT, UPDATE, INSERT, DELETE etc. you required)</font></b></br>'
    // });
    try {
      showLoader();
      const payload = {
        requestNumber: requestData?.requestNumber || "",
        requestedFor: requestData?.requestedFor || "",
        workItemId: requestData?.workItemId || "",
        applicationName: requestData?.applicationName || ""
      }
      const response = await workflowService.getBusinessParams(payload);
      const updatedRequestData = {...requestData, businessDetailsParams: response?.pendingApprovals[0]?.businessDetailsParams}
      updatedRequestData?.businessDetailsParams?.sort?.(
        (a, b) => a.displayOrder - b.displayOrder
      );
      setViewRequestData({ ...updatedRequestData });
      setIsViewModalOpen(true);
    }catch(error){
      toast.error("Something went wrong. Please contact Support for assistance.", "error");
    }finally{
      hideLoader();
    }
  });
  const closeViewModal = () => setIsViewModalOpen(false);
  const initialRef = React.useRef(true);
  useEffect(() => {
    if (initialRef.current) { initialRef.current = false; return; }

    const q = (debouncedSearchTerm ?? "").trim().toLowerCase();

    // one place to handle debounced search (covers search and clear)
    if (q.length >= 3 || q.length === 0) {
      console.log("API call with debouncedSearch:", debouncedSearchTerm);
      loadMoreItems(true);
    }
  }, [debouncedSearchTerm]);

  useEffect(() => {

    // if (changedValue === 'searchTerm') {

    //   const lowerSearch = debouncedSearchTerm?.toLowerCase();
    //   console.log("debouncedSearchTerm:", debouncedSearchTerm);
    //   if (lowerSearch?.length >= 3) {
    //     loadMoreItems(true);
    //     onResetSearch();
    //   }
    //   else if (lowerSearch?.length === 0) {
    //     loadMoreItems(true);
    //     onResetSearch();
    //   }
    //   // onResetSearch();
    // }
    // else 
    if (filterString && changedValue == 'filterString') {
      loadMoreItems(true);
    }
    else if (refresh && changedValue == 'refresh') {
      loadMoreItems(true);
    }
    else if (shouldFetch && ((dateRange.from && dateRange.to) || (!dateRange.from && !dateRange.to)) && changedValue == 'dateRange') {
      loadMoreItems(true);
      if (onResetFetch) {
        onResetFetch();
      }
    }
    // else {
    //   setFilteredItems(allItems);
    // }    
  }, [rowData, searchTerm, debouncedSearchTerm, filterString, dateRange, shouldFetch, refresh]);

  useEffect(() => {
    setIsGridType(displayType === "GRID" ? true : false);
    setCurrentPage(0);
    if(!reFetchAfterClear && !fetchAfterTabChange)loadMoreItems(true);
  }, [displayType, selectedApprovalTabIndex]);

  const loadMoreItems = async (reset = false, isLoadMore = false) => {
    if ((!hasNextPage && !reset) || isFetching) return;

    setIsFetching(true);
    const nextPage = reset ? 0 : currentPage + 1;

    const { rows, hasNext } = await getApprovals(nextPage, itemsPerPage);

    if (rows?.length > 0) {      
      setCurrentPage(nextPage);
      setHasNextPage(hasNext);
      setDisplayedItems(prev => reset ? [...rows] : [...prev, ...rows]);
    }
    else {
      if (isLoadMore) {
        displayedItems?.length === 0 ?? setDisplayedItems([]);
      }
      else {
        setDisplayedItems([]);
      }
      setCurrentPage(nextPage);
      setHasNextPage(false);
    }

    setIsFetching(false);
  };

  const formatLabel = (key) => {
    if (!key) return "";

    return key
      .replace(/([a-z])([A-Z])/g, "$1 $2") // add space only between lower->upper
      .replace(/_/g, " ")             // replace underscores with spaces (if any)
      .trim()                         // remove leading/trailing spaces
      .replace(/\b\w/g, (char) => char.toUpperCase());  // capitalize first letter of each word
  };

  const getSsoFieldValue = (obj, ...keys) => {
    for (const key of keys) {
      if (obj?.[key] !== undefined && obj?.[key] !== null && obj?.[key] !== "") {
        return obj[key];
      }
    }
    return undefined;
  };

  const isYesValue = (value) => {
    if (value === true) return true;
    const normalized = String(value ?? "").trim().toLowerCase();
    return normalized === "yes" || normalized === "true";
  };

  const getTokenValidationStatusText = (status) => {
    const normalized = String(status || '').toUpperCase();
    if (normalized === 'SUCCESS') return 'Success';
    if (normalized === 'ERROR' || normalized === 'FAIL' || normalized === 'FAILED') return 'Failed';
    if (normalized === 'NOT_APPLICABLE') return 'Not Applicable';
    return normalized || 'Unknown';
  };

  const getTokenValidationStatusColor = (status) => {
    const normalized = String(status || '').toUpperCase();
    if (normalized === 'SUCCESS') return 'Green-600';
    if (normalized === 'ERROR' || normalized === 'FAIL' || normalized === 'FAILED') return 'Red-600';
    if (normalized === 'NOT_APPLICABLE') return 'Gray-500';
    return 'Gray-500';
  };

  const getAutomatedDecisionFromTokenStatus = (tokenValidation) => {
    const normalized = String(tokenValidation?.status || '').toUpperCase();
    if (normalized === 'SUCCESS') return 'Approve';
    if (normalized === 'ERROR' || normalized === 'FAIL' || normalized === 'FAILED') return 'Reject';

    const fallback = String(tokenValidation?.meta?.automatedDecision || '').toUpperCase();
    if (fallback === 'APPROVE') return 'Approve';
    if (fallback === 'DENY' || fallback === 'REJECT') return 'Reject';
    return 'N/A';
  };

  const getAutomatedDecisionColor = (tokenValidation) => {
    const decision = getAutomatedDecisionFromTokenStatus(tokenValidation);
    if (decision === 'Approve') return 'Green-600';
    if (decision === 'Reject') return 'Red-600';
    return 'Gray-500';
  };

  const getTokenBadgeStyles = (color) => {
    if (color === 'Green-600') {
      return {
        backgroundColor: '#eef9f0',
        border: '1px solid #8fd19e',
        color: '#2f7d32'
      };
    }

    if (color === 'Red-600') {
      return {
        backgroundColor: '#fff1f1',
        border: '1px solid #e7aaaa',
        color: '#b42318'
      };
    }

    return {
      backgroundColor: '#f3f4f6',
      border: '1px solid #d1d5db',
      color: '#1d4ed8'
    };
  };

  const getApiErrorMessage = (source, fallback = "Something went wrong. Please contact Support for assistance.") => {
    if (!source) return fallback;

    const payload = source?.response?.data || source?.data || source;

    if (typeof payload === "string" && payload.trim()) {
      return payload.trim();
    }

    const message = payload?.errorMessage || payload?.message || payload?.error || source?.message;
    if (typeof message === "string" && message.trim()) {
      return message.trim();
    }

    return fallback;
  };

   useEffect(() => {
    if (!displayedItems || displayedItems.length === 0) return;  
    checkAndAutoLoad();
  }, [displayedItems]);
  const checkAndAutoLoad = () => {
    const container = innerContainerRef.current;
    if (!container) return;
    const noScrollbar = container.scrollHeight <= container.clientHeight;
    // If no scrollbar AND we still have records to load
    if (noScrollbar && hasNextPage && !isFetching) {
      loadMoreItems(false, true);
    }
  };

  const handleScroll = (e) => {
    const currentScrollTop = e.target.scrollTop;
    const isScrollingDown = currentScrollTop > lastScrollTopRef.current;

    const threshold = 2;
    const scrollBottom =
      e.target.scrollHeight - currentScrollTop - e.target.clientHeight;

    if (isScrollingDown && scrollBottom <= threshold) {
      loadMoreItems(false, true);
    }

    lastScrollTopRef.current = currentScrollTop;
  };

  // function filterRecords(filterId) {
  //   const today = new Date();
  //   today.setHours(0, 0, 0, 0);

  //   let filteredResponse = [];
  //   switch (filterId) {
  //     case "Expiring":
  //       filteredResponse = allItems.filter((record) => {
  //         const dueDate = new Date(record.dueDate);
  //         dueDate.setHours(0, 0, 0, 0);
  //         const diffInMs = dueDate - today;
  //         const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
  //         return diffInDays > 0 && diffInDays <= 10;
  //       });
  //       break;
  //     case "Overdue":
  //       filteredResponse = allItems.filter((record) => {
  //         const dueDate = new Date(record.dueDate);
  //         dueDate.setHours(0, 0, 0, 0);
  //         return dueDate < today;
  //       });
  //       break;
  //     case "Pending":
  //     default:
  //       filteredResponse = [...allItems]; // Return all records for "All Time" or unknown filters
  //       break;
  //   }

  //   return filteredResponse;
  // }

  const sendDataToApprovals = (data) => {
    onDataFromPendingApprovals(data);
  };

  
  const checkNavigationOnAction = (type, requestData, selectionType) => {
     if (requestData?.enableRedirection) {
      const w = window.screen.width * .9;
      const h = window.screen.height * .9;
      const l = window.screen.width * .05;
      const t = window.screen.height * .05;
      window.open(requestData?.viewWorkItemUrl, "_blank", `width=${w},height=${h},left=${l},top=${t}`);
    } else {
      if (type == 'Approve') {
        isRetirementApproval ? approveOrRejectAppRetirement('Approve', [requestData]) : isSSOApproval ? approveOrRejectSSORequest('Approve', [requestData]) : isEntraApproval ? approveOrRejectEntraRequest('Approve', [requestData]) : isMyPamApproval ? approveOrRejectMyPamRequest('Approve', [requestData]) : approveOrRejectRequest('Approve', [requestData]); 
      }
    }
  }

  const handleLinkClick = (requestNumber) => {
    const statePayload = { type: "requestNumber", value: requestNumber };
    navigate("/audit-requests", { state: statePayload });
  }

  // const handleSensitiveAction = async () => {
  //   if (oktaAuth.isLoginRedirect()) return null;

  //   const token = await oktaAuth.tokenManager.get("accessToken");

  //   if (!token) {
  //     oktaAuth.setOriginalUri(window.location.pathname);
  //     await oktaAuth.signInWithRedirect();
  //     return null;
  //   }

  //   if (token.claims?.acr !== "urn:okta:loa:2fa:any") {
  //     console.log(token.claims?.acr);
  //     oktaAuth.setOriginalUri(window.location.pathname);
  //     await oktaAuth.signInWithRedirect({
  //       acrValues: "urn:okta:loa:2fa:any"
  //     });
  //     return null;
  //   }

  //   return token;
  // };

  const approveOrRejectMyPamRequest = async(action, actionData, viewType) => {
    let successCount = 0;
    let failCount = 0;

    for (const item of actionData) {
      let requestData;
      requestData = {
        comments: item?.approvalComments || "",
      };
      try {
        showLoader();
        const response = await workflowService.myPamRequestAction(requestData, item?.requestNumber, action);

        if (response?.success) {
          successCount++;
          hideLoader();
          if(changedValue == 'dateRange' || changedValue == 'searchTerm'){
            if(dateRange?.from || dateRange?.to || searchTerm){
              Promise.resolve()
              .then(() => {
                resetFilters();
                handleSearch("");
              })
              .then(() => {
                setTimeout(()=>setShouldReFetch(true),100);
              });
            }
          }
          const updatedDisplayedItems = displayedItems?.filter?.((rec)=>(rec?.requestNumber != item?.requestNumber));
          setDisplayedItems(updatedDisplayedItems);
          const updatedfilteredItems = filteredItemsRef.current?.filter?.((rec)=>(rec?.requestNumber != item?.requestNumber));
          setFilteredItems(updatedfilteredItems);
          filteredItemsRef.current = updatedfilteredItems;
          
          toast.success(
            <div>
              {`${(action === 'Approve' ? 'Approval' : 'Rejection')} triggered for request #${item?.requestNumber} `}
            </div>,
            {
              autoClose: 5000,
              closeOnClick: false,
              position: 'bottom-center'
            }
          );

        } else {
          failCount++;
          hideLoader();
          getApprovals(0, 8);
          toast.error(getApiErrorMessage(response, `Failed to ${action} request #${item?.requestNumber}`), "error");
        }
      } catch (error) {
        failCount++;
        hideLoader();
        toast.error(getApiErrorMessage(error, `Error during request ${item?.requestNumber}`), "error");
      }
    }
    closeModal();
  }

  const approveOrRejectEntraRequest = async(action, actionData, viewType) => {
    let successCount = 0;
    let failCount = 0;

    for (const item of actionData) {
      let requestData;
      requestData = {
        requestNumber: item?.requestNumber,
        actionStatus: action === "Approve" ? "Approve" : "Reject",
        actionComments: item?.approvalComments || "",
        requestType: item?.requestType,
        requestedBy: item?.requestedBy
      };
      try {
        showLoader();
        const response = await workflowService.entraRequestAction(requestData);

        if (response?.status === "Success") {
          successCount++;
          hideLoader();
          if(changedValue == 'dateRange' || changedValue == 'searchTerm'){
            if(dateRange?.from || dateRange?.to || searchTerm){
              Promise.resolve()
              .then(() => {
                resetFilters();
                handleSearch("");
              })
              .then(() => {
                setTimeout(()=>setShouldReFetch(true),100);
              });
            }
          }
          const updatedDisplayedItems = displayedItems?.filter?.((rec)=>(rec?.requestNumber != requestData?.requestNumber));
          setDisplayedItems(updatedDisplayedItems);
          const updatedfilteredItems = filteredItemsRef.current?.filter?.((rec)=>(rec?.requestNumber != requestData?.requestNumber));
          setFilteredItems(updatedfilteredItems);
          filteredItemsRef.current = updatedfilteredItems;
          
          toast.success(
            <div>
              {`${(action === 'Approve' ? 'Approval' : 'Rejection')} triggered for request #${item?.requestNumber} `}
              {/* <span
                onClick={()=>handleLinkClick(item?.requestNumber)}
                style={{ textDecoration: 'underline', fontWeight: "bold", cursor: "pointer"}}
                className="Approvals-toast-click-here"
              >
                Click Here
              </span>
              {` for status`} */}
            </div>,
            {
              autoClose: 5000,
              closeOnClick: false,
              position: 'bottom-center'
            }
          );

        } else {
          failCount++;
          hideLoader();
          getApprovals(0, 8);
          toast.error(getApiErrorMessage(response, `Failed to ${action} request #${item?.requestNumber}`), "error");
        }
      } catch (error) {
        failCount++;
        hideLoader();
        toast.error(getApiErrorMessage(error, `Error during request ${item?.requestNumber}`), "error");
      }
    }
    closeModal();
  }

  const approveOrRejectAppRetirement = async(action, actionData) => {
    let successCount = 0;
    let failCount = 0;

    for (const item of actionData) {
      let requestData;
      requestData = {
        requestNumber: item?.requestNumber,
        taskId: item?.taskId,
        decision: action === "Approve" ? "APPROVE" : "REJECT",
        comments: item?.approvalComments || ""
      };
      try {
        showLoader();
        const response = await workflowService.applicationRetirementProcessDecision(requestData);

        if (response?.status === "APPROVED" || response?.status === "REJECTED") {
          successCount++;
          hideLoader();
          if(changedValue == 'dateRange' || changedValue == 'searchTerm'){
            if(dateRange?.from || dateRange?.to || searchTerm){
              Promise.resolve()
              .then(() => {
                resetFilters();
                handleSearch("");
              })
              .then(() => {
                setTimeout(()=>setShouldReFetch(true),100);
              });
            }
          }
          const updatedDisplayedItems = displayedItems?.filter?.((rec)=>((rec?.requestNumber != requestData?.requestNumber) && (rec?.approvalStep != item?.approvalStep)));
          setDisplayedItems(updatedDisplayedItems);
          const updatedfilteredItems = filteredItemsRef.current?.filter?.((rec)=>((rec?.requestNumber != requestData?.requestNumber) && (rec?.approvalStep != item?.approvalStep)));
          setFilteredItems(updatedfilteredItems);
          filteredItemsRef.current = updatedfilteredItems;
          
          toast.success(
            <div>
              {`${(action === 'Approve' ? 'Approval' : 'Rejection')} triggered for request #${item?.requestNumber} `}
              {/* <span
                onClick={()=>handleLinkClick(item?.requestNumber)}
                style={{ textDecoration: 'underline', fontWeight: "bold", cursor: "pointer"}}
                className="Approvals-toast-click-here"
              >
                Click Here
              </span>
              {` for status`} */}
            </div>,
            {
              autoClose: 5000,
              closeOnClick: false,
              position: 'bottom-center'
            }
          );

        } else {
          failCount++;
          hideLoader();
          getApprovals(0, 8);
          toast.error(getApiErrorMessage(response, `Failed to ${action} request #${item?.requestNumber}`), "error");
        }
      } catch (error) {
        failCount++;
        hideLoader();
        toast.error(getApiErrorMessage(error, `Error during request ${item?.requestNumber}`), "error");
      }
    }
    closeModal();
  }

  const approveOrRejectSSORequest = async (action, actionData, viewType) => {
    let successCount = 0;
    let failCount = 0;

    for (const item of actionData) {
      let requestData;
      requestData = {
        requestNumber: item?.requestNumber || "",
        actionStatus: action === "Approve" ? "Approved" : "Rejected",
        actionComments: item?.approvalComments || "",
      };
      try {
        showLoader();
        const response = await workflowService.ssoRequestAction(requestData);

        if (response?.success || response?.status === "Success" || response?.status === "APPROVED" || response?.status === "REJECTED") {
          successCount++;
          hideLoader();
          if(changedValue == 'dateRange' || changedValue == 'searchTerm'){
            if(dateRange?.from || dateRange?.to || searchTerm){
              Promise.resolve()
              .then(() => {
                resetFilters();
                handleSearch("");
              })
              .then(() => {
                setTimeout(()=>setShouldReFetch(true),100);
              });
            }
          }
          setDisplayedItems(prev => prev?.filter?.((rec)=>rec?.requestNumber !== requestData?.requestNumber));
          const updatedfilteredItems = filteredItemsRef.current?.filter?.((rec)=>rec?.requestNumber !== requestData?.requestNumber);
          setFilteredItems(updatedfilteredItems);
          filteredItemsRef.current = updatedfilteredItems;
          
          toast.success(
            <div>
              {`${(action === 'Approve' ? 'Approval' : 'Rejection')} triggered for SSO request #${item?.requestNumber}`}
            </div>,
            {
              autoClose: 5000,
              closeOnClick: false,
              position: 'bottom-center'
            }
          );

        } else {
          failCount++;
          hideLoader();
          toast.error(getApiErrorMessage(response, `Failed to ${action} SSO request #${item?.requestNumber}`), "error");
        }
      } catch (error) {
        failCount++;
        hideLoader();
        toast.error(getApiErrorMessage(error, `Error during SSO request ${item?.requestNumber}`), "error");
      }
    }
    closeModal();
  };

  const approveOrRejectRequest = async (action, actionData, viewType) => {
    // const res = await handleSensitiveAction();
    
    // if(!res || res?.claims?.acr !== "urn:okta:loa:2fa:any") {
    //   toast.error("Action requires multi-factor authentication. Please complete MFA to proceed.", "error");
    //   return;
    // }
    let userGpId = userData?.accessToken?.claims?.gpid || "";

    let successCount = 0;
    let failCount = 0;

    for (const item of actionData) {
      let requestData;
      // if (roles?.includes("isApprovals")) {
      requestData = {
        // approverGpid: userGpId,
        workItemId: item?.workItemId || "",
        requestNumber: item?.requestNumber,
        enableRedirection: item?.enableRedirection || false,
        actionStatus: action === "Approve" ? "Approved" : "Rejected",
        actionComments: item?.approvalComments || "",
        applicationName: item?.applicationName || "",
        delegatedFrom: item?.delegatedFrom || ""
      };
      // } else {
      //   requestData = {
      //     requestNumber: item?.requestNumber,
      //     enableRedirection: true,
      //     applicationName: item?.requestName || "",
      //   };
      // }
      try {
        showLoader();
        const response = await workflowService.requestAction(requestData);

        if (response?.status === "Success") {
          successCount++;
          hideLoader();
          if(changedValue == 'dateRange' || changedValue == 'searchTerm'){
            if(dateRange?.from || dateRange?.to || searchTerm){
              Promise.resolve()
              .then(() => {
                resetFilters();
                handleSearch("");
              })
              .then(() => {
                setTimeout(()=>setShouldReFetch(true),100);
              });
            }
          }
          //  hideLoader();
          // }else{
          //   showLoader();            
          //     loadMoreItems(true);            
            // if(viewType === 'LIST'){
            //   fetchApprovalsCount();
            // }
            // const updatedDisplayedItems = displayedItems?.filter?.((rec)=>rec?.requestNumber !== requestData?.requestNumber);
            // setDisplayedItems(updatedDisplayedItems);
            // setFilteredItems(updatedDisplayedItems);
          const updatedDisplayedItems = displayedItems?.filter?.((rec)=>(rec?.requestNumber != requestData?.requestNumber || (rec?.requestNumber == requestData?.requestNumber && rec?.applicationName != requestData?.applicationName)));
          setDisplayedItems(updatedDisplayedItems);
          const updatedfilteredItems = filteredItemsRef.current?.filter?.((rec)=>(rec?.requestNumber != requestData?.requestNumber || (rec?.requestNumber == requestData?.requestNumber && rec?.applicationName != requestData?.applicationName)));
          setFilteredItems(updatedfilteredItems);
          filteredItemsRef.current = updatedfilteredItems;
          // const features =
          //   "noopener,noreferrer,width=1200,height=800,resizable,scrollbars";
          // window.open(response?.workItemUrl, "_blank", features);

          // disableItem(item?.requestNumber, item?.applicationName);
          // showToast(`Request ${item?.requestNumber} ${action}d successfully`, "success");
          // toast.success(`Request ${item?.requestNumber} ${action + (action === 'Approve' ? 'd' : 'ed')} successfully`, "success");
          
          toast.success(
            <div>
              {`${(action === 'Approve' ? 'Approval' : 'Rejection')} triggered for request #${item?.requestNumber} `}
              <span
                onClick={()=>handleLinkClick(item?.requestNumber)}
                style={{ textDecoration: 'underline', fontWeight: "bold", cursor: "pointer"}}
                className="Approvals-toast-click-here"
              >
                Click Here
              </span>
              {` for status`}
            </div>,
            {
              autoClose: 5000,
              closeOnClick: false,
              position: 'bottom-center'
            }
          );

        } else {
          failCount++;
          hideLoader();
          getApprovals(0, 8);
          // showToast(`Failed to ${action} request #${item?.requestNumber}`, "error");
          toast.error(getApiErrorMessage(response, `Failed to ${action} request #${item?.requestNumber}`), "error");
        }
      } catch (error) {
        failCount++;
        hideLoader();
        toast.error(getApiErrorMessage(error, `Error during request ${item?.requestNumber}`), "error");
      }
    }

    // Final result after loop finishes
    // toast.info(`${successCount} request(s) ${action}d, ${failCount} failed`, "info");

    // loadMoreItems(true);
    closeModal();
  };

  // const fetchApprovalsCount = async () => {
  //   try {
  //     showLoader();
  //     const response = await landingPageService.fetchRequestCount();
  //     if (response?.responseStatus === "Success") {
  //       hideLoader();
  //       setTotalPages(Math.ceil((response?.myidmCount || 0) / 8));
  //       setTotalCount(response?.myidmCount || 0);
  //       sessionStorage.setItem('myidMApprovalCount', response?.myidmCount || 0);
  //       console.log("Request Count:", response?.myidmCount);
  //     }
  //     else {
  //       hideLoader();
  //       console.error("Failed to fetch request count");
  //     }
  //   } catch (error) {
  //     hideLoader();
  //     console.error("Error fetching request count:", error);
  //   }
  // };

  const disableItem = (id, name) => {
    setDisplayedItems((prev) =>
      prev.map((item) =>
        (item.requestNumber == id && item?.applicationName === name) ? { ...item, isDisabled: true } : item
      )
    );
    setFilteredItems((prev) =>
      prev.map((item) =>
        (item.requestNumber == id && item?.applicationName === name) ? { ...item, isDisabled: true } : item
      )
    );
    filteredItemsRef.current = [...filteredItems].map((item) =>
        (item.requestNumber == id && item?.applicationName === name) ? { ...item, isDisabled: true } : item
    );
    setTimeout(() => {
      setDisplayedItems((prev) =>
        prev.map((item) =>
          (item.requestNumber == id && item?.applicationName === name) ? { ...item, isDisabled: false } : item
        )
      );
      setFilteredItems((prev) =>
        prev.map((item) =>
          (item.requestNumber == id && item?.applicationName === name) ? { ...item, isDisabled: false } : item
        )
      );
      filteredItemsRef.current = [...filteredItems].map((item) =>
          (item.requestNumber == id && item?.applicationName === name) ? { ...item, isDisabled: false } : item
        )
    }, 30 * 1000);
  };

  const [columnDefs] = useState(isRetirementApproval ? [
    {
      headerName: "Actions",
      cellRenderer: ActionCellRender,
      filter: false,
      cellRendererParams: {
        openModal: openModal,
        openViewModal: openRetirementViewModal,
        buttons: [
          { text: t("approvals.approve"), variant: "primary", action: "Approve" },
          { text: t("approvals.reject"), variant: "danger", action: "Reject" },
          { text: t("approvals.view_more"), variant: "auxiliary", action: "View" },
        ],
      },
      field: "actions",
      width: 250
    },
    { headerName: t("myIdmPortal.request_number"), field: "requestNumber", filter: false },
    { headerName: "Application Name", field: "applicationName", filter: false },
    { headerName: "Integration Type", field: "applicationType", filter: false },
    { headerName: "Environment", field: "environment", filter: false },
    { headerName: t("entraGuest.requested_by"), field: "requestedBy", filter: false },
    { headerName: t("entraGuest.requested_by_name"), field: "requestedByUserName", filter: false },
    { headerName: t("entraGuest.requested_on"), field: "timestamp", filter: false }
  ] : isSSOApproval ? [
    {
      headerName: "Actions",
      cellRenderer: ActionCellRender,
      filter: false,
      cellRendererParams: {
        openModal: openModal,
        openViewModal: openSSOViewModal,
        buttons: [
          { text: t("approvals.approve"), variant: "primary", action: "Approve" },
          { text: t("approvals.reject"), variant: "danger", action: "Reject" },
          { text: t("approvals.view_more"), variant: "auxiliary", action: "View" },
        ],
      },
      field: "actions",
      width: 250
    },
    { headerName: t("myIdmPortal.request_number"), field: "requestNumber", filter: false },
    { headerName: "Application Name", field: "applicationName", filter: false },
    { headerName: "Integration Type", field: "applicationType", filter: false },
    { headerName: "Environment", field: "environment", filter: false },
    { headerName: t("entraGuest.requested_by"), field: "requestedBy", filter: false },
    { headerName: t("entraGuest.requested_by_name"), field: "requestedByUserName", filter: false },
    { headerName: t("entraGuest.requested_on"), field: "timestamp", filter: false }
  ]:
  isEntraApproval ? [
    {
      headerName: "Actions",
      cellRenderer: ActionCellRender,
      filter: false,
      cellRendererParams: {
        openModal: openModal,
        openViewModal: openEntraViewModal,
        buttons: [
          { text: t("approvals.approve"), variant: "primary", action: "Approve" },
          { text: t("approvals.reject"), variant: "danger", action: "Reject" },
          { text: t("approvals.view_more"), variant: "auxiliary", action: "View" },
        ],
      },
      field: "actions",
      width: 250
    },
    { headerName: t("myIdmPortal.request_number"), field: "requestNumber", filter: false },
    { headerName: t("entraGuest.requested_by"), field: "requestedBy", filter: false },
    { headerName: t("entraGuest.requested_by_name"), field: "requestedByUserName", filter: false },
    { headerName: t("entraGuest.requested_on"), field: "timestamp", filter: false }
  ]: 
  isMyPamApproval ? [
    {
      headerName: "Actions",
      cellRenderer: ActionCellRender,
      filter: false,
      cellRendererParams: {
        openModal: openModal,
        openViewModal: openMyPamViewModal,
        buttons: [
          { text: t("approvals.approve"), variant: "primary", action: "Approve" },
          { text: t("approvals.reject"), variant: "danger", action: "Reject" },
          { text: t("approvals.view_more"), variant: "auxiliary", action: "View" },
        ],
      },
      field: "actions",
      width: 250
    },
    { headerName: t("myIdmPortal.request_number"), field: "requestNumber", filter: false },
    { headerName: t("mypam.application_name"), field: "applicationName", filter: false },
    { headerName: t("entraGuest.requested_by"), field: "requestedBy", filter: false },
    { headerName: t("mypam.request_type"), field: "requestType", filter: false },
    { headerName: t("entraGuest.requested_on"), field: "timestamp", filter: false }
  ] 
  :
  [
    // {
    //   headerName: '',
    //   checkboxSelection: true,
    //   suppressMenu: true,
    //   filter: false,
    //   // headerCheckboxSelection: true,       // ✅ Adds select-all checkbox
    //   // headerCheckboxSelectionFilteredOnly: true, // optional: only current filter
    //   width: 50,
    // },
    {
      headerName: "Actions",
      cellRenderer: ActionCellRender,
      filter: false,
      cellRendererParams: {
        openModal: openModal,
        openViewModal: openViewModal,
        buttons: [
          { text: "Approve", variant: "primary", action: "Approve" },
          { text: "Reject", variant: "danger", action: "Reject" },
          { text: "View More", variant: "auxiliary", action: "View" },
        ],
      },
      field: "actions",
      width: 250
    },
    { headerName: "Request Number", field: "requestNumber", filter: false },
    // { headerName: "Application Name", field: "applicationName", cellRenderer: CustomTooltipCellRenderer, filter: false },
    { headerName: "Application Name", field: "applicationName", filter: false },
    // { headerName: "Application Desc", field: "applicationDesc", cellRenderer: CustomTooltipCellRenderer },
    // { headerName: "Request Type", field: "requestType", cellRenderer: CustomCellRender, filter: false },
    { headerName: "Request Type", field: "requestType", filter: false },
    { headerName: "Requested For", field: "requestedFor", filter: false },
    { headerName: "Requested For(Name)", field: "userName", filter: false },
    { headerName: "Requested By", field: "requestedBy", filter: false },
    { headerName: "Requested By(Name)", field: "requestedByUserName", filter: false },
    { headerName: "Requested On", field: "timestamp", filter: false },
    { headerName: "Location", field: "requestLocation", cellRenderer: CustomTooltipCellRenderer, filter: false }
  ]);

  const getDataFromGrid = (rows) => {
    if (rows.length === 0) {
      setSelectedRows([]);
    }
    else {
      setSelectedRows(rows);
    }
    console.log("Selected rows from grid:", rows);
  };

  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const getApprovals = async (page, pageSize) => {
    if(isEntraApproval){
      try {
      const body = {
        pagination: {
          page: page || 0,
          pageSize: pageSize || 8,
        },
        searchFilter: searchTerm || "",
      };
      
      if (dateRange?.from && dateRange?.to) {
        body.dateFilter = {
          startDate: dateRange?.from ? formatDate(dateRange.from) : null,
          endDate: dateRange?.to ? formatDate(dateRange.to) : null
        };
      }

      showLoader();
      const response = await workflowService.getEntraPendingRequests(body);
      // const duplicateCheck = {};   // extra object to track unique keys
      // const resultPendingApprovals = [];

      // for (const item of response.pendingRequests) {
      //   const key = `${item.requestNumber}-${item.applicationName}`;
      //   if (!duplicateCheck[key]) {
      //     duplicateCheck[key] = true;
      //     resultPendingApprovals.push(item);
      //   }
      // }

      // const removedDiplicateRecords = {...response, pendingApprovals:resultPendingApprovals}
      const items = response?.pendingRequests.map((item)=>({...item, requestedByUserName: item?.requesterName, timestamp: item?.requestedOnDate?.split?.(" ")?.[0]})) || [];
      // if (items.length === 0) {
      //   toast.success(t("entraGuest.no_requests_found"), "success");
      // }
      onShowErrorPage(false);
      const nextFlag = response?.hasNext ?? false;
      setHasNextPage(nextFlag);
      const mapped = items.map((item, index) => {
        // if (!item || !item.timestamp) return item;

        const dueDate = new Date(item?.requestedOnDate?.replace(" ", "T"));
        const now = new Date();

        const diffInMs = dueDate - now;
        const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

        return {
          ...item,
          keyId: `${item.requestNumber}-${Date.now()}-${index}`,
          dueStatusCode: diffInDays > 0 ? "Expiring" : diffInDays === 0 ? "Due Today" : "Overdue",
          dueStatus:
            diffInDays > 0
              ? `Expiring in ${diffInDays} days`
              : diffInDays === 0
                ? "Due today"
                : `Overdue`,
        };
      });

      setFilteredItems(mapped);
      filteredItemsRef.current = mapped;

      hideLoader();

      return {
        rows: mapped,
        hasNext: response?.hasNext ?? false,
        totalCount: response?.totalCount || 50,
      };
    }
    catch (error) {
      console.error("Error fetching approvals:", error);
      hideLoader();
      onShowErrorPage(true);
      let response = [];
      setAllItems(response);
      setFilteredItems(response);
      filteredItemsRef.current = response
      setDisplayedItems(response);

      setHasNextPage(true);
      return {
        rows: response,
        hasNext: true,
        totalCount: 50,
      };
    }
    }
    else if(isRetirementApproval){
      try {
      const body = {
        pagination: {
          page: page || 0,
          pageSize: pageSize || 8,
        },
        searchFilter: searchTerm || "",
      };
      
      if (dateRange?.from && dateRange?.to) {
        body.dateFilter = {
          startDate: dateRange?.from ? formatDate(dateRange.from) : null,
          endDate: dateRange?.to ? formatDate(dateRange.to) : null
        };
      }

      showLoader();
      const response = await workflowService.getApplicationRetirementPendingRequests(body);
      const items = response?.pendingApprovals?.map?.((r)=>({...r, userName: r?.username})) || [];
      onShowErrorPage(false);
      const nextFlag = response?.hasNext ?? false;
      setHasNextPage(nextFlag);
      const mapped = items.map((item, index) => {
        const dueDate = new Date(item?.requestedOnDate?.replace(" ", "T"));
        const now = new Date();

        const diffInMs = dueDate - now;
        const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

        return {
          ...item,
          keyId: `${item.requestNumber}-${Date.now()}-${index}`,
          dueStatusCode: diffInDays > 0 ? "Expiring" : diffInDays === 0 ? "Due Today" : "Overdue",
          dueStatus:
            diffInDays > 0
              ? `Expiring in ${diffInDays} days`
              : diffInDays === 0
                ? "Due today"
                : `Overdue`,
        };
      });

      setFilteredItems(mapped);
      filteredItemsRef.current = mapped;

      hideLoader();

      return {
        rows: mapped,
        hasNext: response?.hasNext ?? false,
        totalCount: response?.totalCount || 50,
      };
    }
    catch (error) {
      console.error("Error fetching approvals:", error);
      hideLoader();
      onShowErrorPage(true);
      let response = [];
      setAllItems(response);
      setFilteredItems(response);
      filteredItemsRef.current = response
      setDisplayedItems(response);

      setHasNextPage(true);
      return {
        rows: response,
        hasNext: true,
        totalCount: 50,
      };
    }
    }
    else if(isSSOApproval){
      try {
      const normalizedSearch = (searchTerm || "").trim().toLowerCase();
      const isSSOSearchActive = normalizedSearch.length >= 3;
      const body = {
        pagination: {
          page: isSSOSearchActive ? 0 : (page || 0),
          pageSize: isSSOSearchActive ? 250 : (pageSize || 8),
        },
        searchFilter: searchTerm || "",
      };
      
      if (dateRange?.from && dateRange?.to) {
        body.dateFilter = {
          startDate: dateRange?.from ? formatDate(dateRange.from) : null,
          endDate: dateRange?.to ? formatDate(dateRange.to) : null
        };
      }

      showLoader();
      const response = await workflowService.getSSOPendingApprovals(body);
      const items = response?.pendingApprovals?.map((item) => ({
        ...item,
        timestamp: item?.createTime ? new Date(item.createTime).toLocaleDateString() : '',
        requestedBy: item?.requestor || item?.requesterGpid || item?.requestedBy,
        requestedByUserName: item?.requestorName || item?.requesterName || item?.requestedByName,
        userName: item?.assigneeName,
        applicationName: resolveApplicationName(item),
        applicationType: item?.applicationType || item?.requestDetails?.displayFields?.['Integration Type'] || item?.requestDetails?.rawRequest?.type || '',
        environment: item?.environment || item?.requestDetails?.displayFields?.['Environment'] || '',
        // Flatten displayFields for view more modal
        displayFields: item?.requestDetails?.displayFields || {},
        rawRequest: item?.requestDetails?.rawRequest || {}
      })) || [];

      const searchFilteredItems = isSSOSearchActive
        ? items.filter((item) => {
            const requestNumber = item?.requestNumber?.toLowerCase?.() || "";
            const applicationName = item?.applicationName?.toLowerCase?.() || "";
            const requestedBy = item?.requestedBy?.toLowerCase?.() || "";
            const requestedByUserName = item?.requestedByUserName?.toLowerCase?.() || "";

            return (
              requestNumber.includes(normalizedSearch) ||
              applicationName.includes(normalizedSearch) ||
              requestedBy.includes(normalizedSearch) ||
              requestedByUserName.includes(normalizedSearch)
            );
          })
        : items;
      
      onShowErrorPage(false);
      const nextFlag = isSSOSearchActive ? false : (response?.hasNext ?? false);
      setHasNextPage(nextFlag);
      const mapped = searchFilteredItems.map((item, index) => {
        const dueDate = item?.createTime ? new Date(item.createTime) : new Date();
        const now = new Date();

        const diffInMs = dueDate - now;
        const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

        return {
          ...item,
          keyId: `${item.requestNumber}-${Date.now()}-${index}`,
          dueStatusCode: diffInDays > 0 ? "Expiring" : diffInDays === 0 ? "Due Today" : "Overdue",
          dueStatus:
            diffInDays > 0
              ? `Expiring in ${diffInDays} days`
              : diffInDays === 0
                ? "Due today"
                : `Overdue`,
        };
      });

      setFilteredItems(mapped);
      filteredItemsRef.current = mapped;

      hideLoader();

      return {
        rows: mapped,
        hasNext: nextFlag,
        totalCount: isSSOSearchActive ? mapped.length : (response?.totalCount || 50),
      };
    }
    catch (error) {
        console.error("Error fetching SSO approvals:", error);
        hideLoader();
        onShowErrorPage(true);
        let response = [];
        setAllItems(response);
        setFilteredItems(response);
        filteredItemsRef.current = response
        setDisplayedItems(response);

        setHasNextPage(true);
        return {
          rows: response,
          hasNext: true,
          totalCount: 50,
        };
      }
    }
    else if(isMyPamApproval){
      try {
      const body = {
        pagination: {
          page: page || 0,
          pageSize: pageSize || 8,
        },
        searchFilter: searchTerm || "",
      };
      
      if (dateRange?.from && dateRange?.to) {
        body.dateFilter = {
          startDate: dateRange?.from ? formatDate(dateRange.from) : null,
          endDate: dateRange?.to ? formatDate(dateRange.to) : null
        };
      }

      showLoader();
      const response = await workflowService.getMyPamPendingRequests(body);
      // const duplicateCheck = {};   // extra object to track unique keys
      // const resultPendingApprovals = [];

      // for (const item of response.pendingRequests) {
      //   const key = `${item.requestNumber}-${item.applicationName}`;
      //   if (!duplicateCheck[key]) {
      //     duplicateCheck[key] = true;
      //     resultPendingApprovals.push(item);
      //   }
      // }

      // const removedDiplicateRecords = {...response, pendingApprovals:resultPendingApprovals}
      const items = response?.pendingApprovals.map((item)=>({...item,timestamp: item?.createdAt?.split?.(" ")?.[0], requestedBy: item?.requesterGpid, requestedFor: item?.requestedForGpid, requestedByUserName: item?.requesterName, userName: item?.requestedForName})) || [];
      // if (items.length === 0) {
      //   toast.success(t("entraGuest.no_requests_found"), "success");
      // }
      onShowErrorPage(false);
      const nextFlag = response?.hasNext ?? false;
      setHasNextPage(nextFlag);
      const mapped = items.map((item, index) => {

        const dueDate = new Date(item?.createdAt?.replace(" ", "T"));
        const now = new Date();

        const diffInMs = dueDate - now;
        const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

        return {
          ...item,
          keyId: `${item.requestNumber}-${Date.now()}-${index}`,
          dueStatusCode: diffInDays > 0 ? "Expiring" : diffInDays === 0 ? "Due Today" : "Overdue",
          dueStatus:
            diffInDays > 0
              ? `Expiring in ${diffInDays} days`
              : diffInDays === 0
                ? "Due today"
                : `Overdue`,
        };
      });

      setFilteredItems(mapped);
      filteredItemsRef.current = mapped;

      hideLoader();

      return {
        rows: mapped,
        hasNext: response?.hasNext ?? false,
        totalCount: response?.totalCount || 50,
      };
    }
    catch (error) {
        console.error("Error fetching approvals:", error);
        hideLoader();
        onShowErrorPage(true);
        let response = [];
        setAllItems(response);
        setFilteredItems(response);
        filteredItemsRef.current = response
        setDisplayedItems(response);

        setHasNextPage(true);
        return {
          rows: response,
          hasNext: true,
          totalCount: 50,
        };
      }
    }
    else{
      try {
      const body = {
        pagination: {
          page: page || 0,
          pageSize: pageSize || 8,
        },

        "searchFilter": searchTerm || "",
      };
      if (dateRange?.from && dateRange?.to) {
        body.dateFilter = {
          startDate: dateRange?.from ? formatDate(dateRange.from) : null,
          endDate: dateRange?.to ? formatDate(dateRange.to) : null
        };
      }

      showLoader();
      const response = await workflowService.getApprovals(body);
      const duplicateCheck = {};   // extra object to track unique keys
      const resultPendingApprovals = [];

      for (const item of response.pendingApprovals) {
        const key = `${item.requestNumber}-${item.applicationName}`;
        if (!duplicateCheck[key]) {
          duplicateCheck[key] = true;
          resultPendingApprovals.push(item);
        }
      }

      const removedDiplicateRecords = {...response, pendingApprovals:resultPendingApprovals}
      const items = (removedDiplicateRecords?.pendingApprovals || []).map((item) => ({
        ...item,
        applicationName: resolveApplicationName(item),
      }));
      // if (items.length === 0) {
      //   toast.success(`No approvals found`, "success");
      // }
      onShowErrorPage(false);
      const nextFlag = removedDiplicateRecords?.hasNext ?? false;
      setHasNextPage(nextFlag);
      const mapped = items.map((item, index) => {
        if (!item || !item.timestamp) return item;

        const dueDate = new Date(item?.dueDate?.replace(" ", "T"));
        const now = new Date();

        const diffInMs = dueDate - now;
        const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

        return {
          ...item,
          keyId: `${item.requestNumber}-${Date.now()}-${index}`,
          dueStatusCode: diffInDays > 0 ? "Expiring" : diffInDays === 0 ? "Due Today" : "Overdue",
          dueStatus:
            diffInDays > 0
              ? `Expiring in ${diffInDays} days`
              : diffInDays === 0
                ? "Due today"
                : `Overdue`,
        };
      });

      setFilteredItems(mapped);
      filteredItemsRef.current = mapped;

      hideLoader();

      return {
        rows: mapped,
        hasNext: removedDiplicateRecords?.hasNext ?? false,
        totalCount: removedDiplicateRecords?.totalCount || 50,
      };
    }
    catch (error) {
      console.error("Error fetching approvals:", error);
      hideLoader();
      onShowErrorPage(true);
      let response = [];
      setAllItems(response);
      setFilteredItems(response);
      filteredItemsRef.current = response
      setDisplayedItems(response);

      setHasNextPage(true);
      return {
        rows: response,
        hasNext: true,
        totalCount: 50,
      };
    }
    }
  };

  const convertDateFormat = (dateStr) => {
    const [datePart, time, tz] = dateStr.split(" "); // ["15-10-2025", "23:32", "CST"]
    const [day, month, year] = datePart.split("-");
    return `${month}-${day}-${year} ${time} ${tz}`;
  };

  const fetchApprovals = (page, pageSize) => {
    var gpid;
    const data = JSON.parse(localStorage.getItem("okta-token-storage"));
    if (!gpid && data?.accessToken?.claims?.gpid) {
      gpid = data?.accessToken?.claims?.gpid
    }
    if (!gpid && window?.location?.hostname?.includes("localhost")) {
      gpid = "44442888"
    }
    return getApprovals(page, pageSize);
  };

  const setGridPaginationInfo = (event) => {
    const { page, pageSize } = event;
    if (page !== currentPage) {
      setCurrentPage(page);
      getApprovals(page);
    }
    // setItemsPerPage(pageSize);
  }

  const startWorkflow = () => {
    navigate("/workflow");
  };
  const modifyRequestData = () => {
    const modifyRequestURl =
      "https://myidm.qa.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.nest.wfitem=1+4+19103%3AWPDS";
    window.open(modifyRequestURl, "_blank");
    // navigate("https://myidm.qa.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.nest.wfitem=1+4+19103%3AWPDS");
  };

  return (
    <div id="pending_Approvals" ref={containerRef} >
      {isGridType && (
        <div className="cards-container-scrollable"
          onScroll={handleScroll}
          ref={innerContainerRef}
          style={{
            height: 'calc(100vh - 295px)',
            overflowY: 'auto',
          }}>
          <div className="d-flex">
            <div className="cards-container">
              {displayedItems?.length > 0 ? (
                displayedItems.map((card, index) => (
                  <div className="card approvalCard" key={card?.keyId}>
                    <div className="card-content">
                      <div className="d-flex w-100 justify-content-between mt-2">
                        <div className="approvalHeader px-3 py-2" > {/*onClick={() => startWorkflow()}*/}
                          <div className="d-flex w-100 justify-content-between pb-2">
                            <span>Request Number : {card.requestNumber}</span>
                            {/* <Tag color={card.dueStatusCode === 'Expiring' ? "Orange-150" : card.dueStatusCode === 'Overdue' ? "Red-150" : ""} type="faded" iconLeading="" size="large" text={card.dueStatus} /> */}
                          </div>
                          {/* <Button
                            className="p-4"
                            size="small"
                            text={card?.applicationName || "Application Name"}
                            variant="secondary"
                            iconTrailing="info"
                            data-tooltip-id="appName-tooltip" data-tooltip-content={card.applicationName || "Application Name"}
                          /> */}
                          {
                          isMyPamApproval ? 
                          <span className="appCardHeader">{card?.requestType === "MYPAM_SAFE_ACCESS" ? t("mypam.myPAM_safe_access_request") : t("mypam.myPAM_safe_management")}</span>
                          : isSSOApproval ?
                          <>
                            <span className="appCardHeader" data-tooltip-id={`appName-tooltip-index-${index}`} data-tooltip-content={card?.applicationName || card?.requestDetails?.displayFields?.['Application Name']}>{card?.applicationName || card?.requestDetails?.displayFields?.['Application Name']}</span>
                            <Tooltip id={`appName-tooltip-index-${index}`} place="top" style={{ maxWidth: '200px' }} type="light" effect="solid" />
                          </>
                          :
                          <>
                            <span className="appCardHeader" data-tooltip-id={`appName-tooltip-index-${index}`} data-tooltip-content={card.applicationName || "Application Name"}>{card?.applicationName || "Application Name"}</span>
                            <Tooltip id={`appName-tooltip-index-${index}`} place="top" style={{ maxWidth: '200px' }} type="light" effect="solid" />
                          </>
                          }
                        </div>
                        {/* <Icon icon="more_vert" /> */}
                      </div>
                      <div className="d-grid w-100 mt-8 mr-2" style={{ gap: "4px" }}>
                        {(card?.requestType || card?.typeCodeDescription) && (
                          <div className="d-flex w-100" style={{ gap: "4px" }}>
                            <Icon icon="assignment" size="medium" style={{ color: '#3a3a3a' }} />
                            <div className="approvalCardLabel">Request Type :</div>
                            <div className="approvalCardValue approvalCardValueBorder" style={{maxWidth:"200px", cursor:"default"}} data-tooltip-id={`requestType-tooltip-index-${index}`} data-tooltip-content={((card.requestType || card.typeCodeDescription)?.startsWith("MYPAM_") ? formatMyPAMRequestType(card.requestType || card.typeCodeDescription) : (card.requestType || card.typeCodeDescription)) || "Request Type"}>
                              <div
                                style={{
                                  color: 'var(--Tokens-Text-Primary, #3A3A3A)',
                                  fontFeatureSettings: '"liga" off, "clig" off',
                                  alignSelf: 'stretch',
                                  borderRadius: 'var(--Corner-radius-corner-radius-xsmall, 4px)',
                                  minHeight: '20px',
                                  gap: 'var(--Spacing-spacing-2, 2px)',
                                  padding: 'var(--Spacing-spacing-01, 2px) var(--Spacing-spacing-8, 8px)',
                                  backgroundColor:
                                    (card.requestType || card.typeCodeDescription) === 'NEW'
                                      ? '#B3DACB'
                                      : (card.requestType || card.typeCodeDescription) === 'MODIFY'
                                        ? '#FFDCBB'
                                        : (card.requestType || card.typeCodeDescription) === 'DISABLED'
                                          ? '#6b7280'
                                          : '',
                                  font: 'var(--Font-Size-Small, 12px) / var(--Line-Height-XSmall, 18px) var(--Typography-Font-Family-Body, Inter)',
                                  width: "100%",
                                  whiteSpace: "nowrap",
                                  textOverflow: "ellipsis"
                                }}
                              >
                                {((card.requestType || card.typeCodeDescription)?.startsWith("MYPAM_") ? formatMyPAMRequestType(card.requestType || card.typeCodeDescription) : (card.requestType || card.typeCodeDescription))}
                              </div>
                              {/* <Tag color={card.requestType === 'NEW' ? 'Green-600' : card.requestType === 'MODIFY' ? 'Orange-400' : card.requestType === 'DISABLED' ? 'Gray-500' : ''} iconLeading={card.requestType === 'NEW' ? "error_outline" : null} size="large" text={card.requestType} type="outlined" /> */}
                            </div>
                            <Tooltip id={`requestType-tooltip-index-${index}`} place="top" style={{ maxWidth: '200px' }} type="light" effect="solid" />
                          </div>
                        )}
                        {card?.timestamp && (
                          <div className="d-flex w-100" style={{ gap: "4px" }}>
                            <Icon icon="calendar_today" size="medium" style={{ color: '#3a3a3a' }} />
                            <div className="approvalCardLabel">Requested On:</div>
                            <div className="approvalCardValue ">{card.timestamp}</div>
                          </div>
                        )}
                        {card?.requestLocation && (
                          <div className="d-flex w-100" style={{ gap: "4px" }}>
                            <Icon icon="location_on" size="medium" style={{ color: '#3a3a3a' }} />
                            <div className="approvalCardLabel">Location :</div>
                            <div className="approvalCardValue" data-tooltip-id={`location-tooltip-${index}`} data-tooltip-content={card.requestLocation}>
                              {card.requestLocation}
                            </div>
                            <Tooltip id={`location-tooltip-${index}`} place="top" style={{ maxWidth: '200px' }} type="light" effect="solid" />
                          </div>
                        )}
                        <hr className="custom-hr" />
                        <div className={isMobile ? "d-grid w-100" : "d-flex w-100"} style={{ gap: "4px" }}>
                          {card?.requestedFor && (
                            <div className={isMobile ? "d-grid w-100" : "d-grid w-50"} style={{ gap: "4px" }}>
                              <div className="approvalInfoLabel">Requested For</div>
                              <div className="approvalRequestInfoValue"> <span>GPID : </span>
                                <span data-tooltip-id={`requested-for-gpid-tooltip-${index}`} data-tooltip-content={card.requestedFor}>{card.requestedFor}</span>
                                <Tooltip id={`requested-for-gpid-tooltip-${index}`} place="top" style={{ maxWidth: '200px' }} type="light" effect="solid" />
                              </div>
                              <div className="approvalRequestInfoValue"> <span>Name : </span>
                                <span data-tooltip-id={`requested-for-tooltip-${index}`} data-tooltip-content={card.userName || t("auditRequest.not_applicable")}> {card?.userName || t("auditRequest.not_applicable")}</span>
                                <Tooltip id={`requested-for-tooltip-${index}`} place="top" style={{ maxWidth: '200px' }} type="light" effect="solid" />
                              </div>
                            </div>
                          )}
                          {card?.requestedBy && (
                            <div className={(isMobile || isEntraApproval || isSSOApproval) ? "d-grid w-100" : "d-grid w-50"} style={{ gap: "4px" }}>
                              <div className="approvalInfoLabel">Requested By</div>
                              <div className="approvalRequestInfoValue"><span>GPID : </span>
                                <span data-tooltip-id={`requested-by-gpid-tooltip-${index}`} data-tooltip-content={card.requestedBy}>{card.requestedBy}</span>
                                <Tooltip id={`requested-by-gpid-tooltip-${index}`} place="top" style={{ maxWidth: '200px' }} type="light" effect="solid" />
                              </div>
                              <div className="approvalRequestInfoValue" style={{...((isEntraApproval || isSSOApproval) && {maxWidth: '100%'})}}> <span>Name : </span>
                                <span data-tooltip-id={`requested-by-user-tooltip-${index}`} data-tooltip-content={card?.requestedByUserName || t("auditRequest.not_applicable")}>{card?.requestedByUserName || t("auditRequest.not_applicable")}</span>
                                <Tooltip id={`requested-by-user-tooltip-${index}`} place="top" style={{ maxWidth: '200px' }} type="light" effect="solid" />
                              </div>
                            </div>
                          )}
                          {/* <div className="d-flex" style={{ gap: "8px" }}>
                          <Button
                            size="small"
                            text="Approve"
                            variant="primary"
                            iconLeading="check"
                            style={{ height: '24px !important' }}
                            onClick={() => { openModal('Approve', card) }}
                          />
                          <Button
                            size="small"
                            text="Deny"
                            variant="primaryInverse"
                            iconLeading="close"
                            onClick={() => { openModal('Reject', card) }}
                          />

                        </div> */}
                        </div>
                      </div>

                      <div className="d-flex w-100 mt-4" style={{ justifyContent: "space-between" }}>
                        <div className="d-flex" style={{ gap: "8px" }}>
                          <Button
                            className="approval-btn"
                            size="small"
                            disabled={card?.isDisabled}
                            text="Approve"
                            variant="primary"
                            iconLeading="check"
                            onClick={() => { checkNavigationOnAction('Approve', card); }}
                          />
                          <Button
                            className="deny-btn"
                            size="small"
                            disabled={card?.isDisabled}
                            text={t("approvals.reject")}
                            variant="primaryInverse"
                            iconLeading="close"
                            onClick={() => { openModal('Reject', card, 'single') }}
                          />
                        </div>
                        <div>
                          <Button
                            size="small"
                            text="View More"
                            variant="primaryInverse"
                            iconTrailing="arrow_forward"
                            disabled={!card?.requestNumber}
                            onClick={() => { 
                              if(isSSOApproval){
                                openSSOViewModal('View', card)
                              }else if(isRetirementApproval){
                                openRetirementViewModal('View', card)
                              }else if(isEntraApproval){
                                openEntraViewModal('View', card)
                              }else if(isMyPamApproval){
                                openMyPamViewModal('View', card)
                              }else{
                                openViewModal('View', card) 
                              }
                            }}
                          />
                        </div>
                      </div>
                      {/* )} */}
                    </div>
                  </div>
                ))
              ) : displayedItems?.length === 0 ? (
                // <div className={isMobile ? "no-data-message d-flex" : "no-data-message d-flex"}>
                //   <Icon icon="info" size="large" />
                //   <span>No pending approvals found</span>
                // </div>
                <div className="w-100 d-flex justify-content-center">
                  <NoDataFound mainHeading ={t("homePage.no_pending_approvals_found")}/>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      )}

      {!isGridType && (
        <div className="d-grid">
          {/* {selectedRows.length > 1 && <div className={isMobile ? "d-flex mb-2 justify-content-center" : "d-flex mb-2 justify-content-start"} >
            <Button
              size="medium"
              text="Approve"
              className="gridActionButton"
              style={{ width: isMobile ? "100%" : "20%" }}
              variant="primary"
              iconLeading="check"
              onClick={() => { openModal('Approve', selectedRows, 'multiple') }}
            />
            <Button
              size="medium"
              text="Deny"
              className="gridActionButton"
              style={{ width: isMobile ? "100%" : "20%" }}
              variant="tertiary"
              iconLeading="close"
              onClick={() => { openModal('Reject', selectedRows, 'multiple') }}
            />
          </div>
          } */}
          <div className="table-container approvals-table">
            <AgGridComponent
              columnDefs={columnDefs}
              rowData={filteredItems}
              rowSelection="single"
              fetchData={fetchApprovals}
              suppressMovableColumns={true}
              gridHeight={"calc(100vh - 264px)"}
              // ref={agGridRef}
              // checkedIndexes={checkedIndexes}
              isEntraApproval={isEntraApproval}
              isMyPamApproval={isMyPamApproval}
              isSSOApproval={isSSOApproval}
              isRetirementApproval={isRetirementApproval}
              sendSelectedRows={getDataFromGrid}
              pagination={true}
              paginationPageSize={itemsPerPage}
              sendPaginationInfo={setGridPaginationInfo}
              hasNextPage={hasNextPage}
              currentPage={currentPage}
            />
          </div>
        </div>
      )}
      <Modal
        id="actionModal"
        className={`${approvalData?.[0]?.type === "Approve" ? '' : 'reject-type-modal'} approval-reject-modal`}
        closeOnOutsideClick = {false}
        onCloseModal={closeModal}
        showCloseButton
        showModal={isModalOpen}
        style={{}}
        tertiaryButtonProps=""
        showAuxiliaryButton={false}
        showSecondaryButton
        secondaryButtonProps={{
          onClick: () => closeModal(),
          size: 'medium',
          text: 'Cancel',
          variant: 'secondary',
          className: "reject-modal-cancel-button",
        }}
        primaryButtonProps={{
          text: approvalData?.[0]?.type === "Approve" ? "Approve" : t("homePage.reject_application"),
          variant: "primary",
          disabled: approvalData?.[0]?.type === "Reject" && (!approvalData?.[0]?.approvalComments || approvalData?.[0]?.approvalComments.trim() === ""),
          onClick: async () => {
            closeModal();
            if (approvalData?.[0]?.type === "Approve") {
              // Call approve API
              isRetirementApproval ? approveOrRejectAppRetirement('Approve', approvalData) : isSSOApproval ? approveOrRejectSSORequest('Approve', approvalData) : isEntraApproval ? approveOrRejectEntraRequest('Approve', approvalData) : isMyPamApproval ? approveOrRejectMyPamRequest('Approve', approvalData) : approveOrRejectRequest('Approve', approvalData);
            }
            else {
              // Call reject API
              isRetirementApproval ? approveOrRejectAppRetirement('Reject', approvalData) : isSSOApproval ? approveOrRejectSSORequest('Reject', approvalData) : isEntraApproval ? approveOrRejectEntraRequest('Reject', approvalData) : isMyPamApproval ? approveOrRejectMyPamRequest('Reject', approvalData) : approveOrRejectRequest('Reject', approvalData);
            }
          },
        }}
        text={
          approvalData?.[0]?.type === "Approve" ? (
            <>
              This action will {approvalData?.[0]?.type === "Approve" ? "Approve" : ""}{" "}
              {approvalData?.length === 1 ? (
                <strong>
                  request #{approvalData?.[0]?.requestNumber} application
                </strong>
              ) : (
                <span>request for the following application</span>
              )}
            </>
          ) : (
            <span>{t("homePage.approval_rejection_modal_text")}</span>
          )
        }
        title={approvalData?.[0]?.type === "Approve" ? "Approve Request" : t("homePage.approval_rejection_modal_title")}
        type="fluid"
        size="medium"
      >
        <div className={`${approvalData?.[0]?.type === "Approve" ? '' : 'd-flex justify-content-center'}`}>
          {approvalData?.[0]?.type === "Approve" ? (
            approvalData?.length > 1 ? (
              approvalData.map((item, index) => (
                <div key={index} className={isMobile ? "d-grid w-100" : "d-flex w-100"} style={{ gap: "8px" }}>
                  <div className="d-grid w-100">
                    <div className="approvalInfoLabel">Request Number</div>
                    <div className="approvalInfoValue">{item.requestNumber}</div>
                  </div>
                  <div className="d-grid w-100">
                    <div className="approvalInfoLabel">Requested For</div>
                    <div className="approvalInfoValue">{item.requestedFor}</div>
                  </div>
                  <div className="d-grid w-100">
                    <div className="approvalInfoLabel">Requested By</div>
                    <div className="approvalInfoValue">{item.requestedBy}</div>
                  </div>
                  <div className="d-grid w-100">
                    <div className="approvalInfoLabel">Application Name</div>
                    <div className="approvalInfoValue">{item.applicationName}</div>
                  </div>
                  <div className="d-grid w-100">
                    <div className="approvalInfoLabel">Application Description</div>
                    <div className="approvalInfoValue">{item.applicationDesc}</div>
                  </div>

                </div>
              ))
            ) : (
              <div className="d-grid w-100" style={{ gap: "8px" }}>
                <div className="approvalInfoLabel">Requested For</div>
                <div className="approvalInfoValue">{approvalData?.[0]?.requestedFor}</div>
                <div className="approvalInfoLabel">Requested By</div>
                <div className="approvalInfoValue">{approvalData?.[0]?.requestedBy}</div>
                <div className="approvalInfoLabel">Application Name</div>
                <div className="approvalInfoValue">{approvalData?.[0]?.applicationName}</div>
                <div className="approvalInfoLabel">Application Description</div>
                <div className="approvalInfoValue">{approvalData?.[0]?.applicationDesc}</div>
              </div>
            )
          ) : (
            <TextArea title="Reason for Rejection" label="Reason for Rejection"
              className="reason-for-rejection"
              placeholder="Please provide a reason for rejection"
              rows={isMobile || isTab ? 8 : 4}
              style={{ width: "100%" }}
              required={true}
              onChange={(e) => setApprovalData([{ ...approvalData?.[0], approvalComments: e.target.value }])}
              value={approvalData?.[0]?.approvalComments || ""}
              showToolbar={false}
              showCharacterCount={false}
              maxLength={200}
            />
          )
          }
        </div>
      </Modal>
      <Modal
        size="large"
        id="viewRequestModal"
        className={isMobile || isTab ? "mobile-view-request-modal" : ""}
        closeOnOutsideClick = {false}
        onCloseModal={closeViewModal}
        showCloseButton
        showModal={isViewModalOpen}
        style={{}}
        tertiaryButtonProps=""
        showAuxiliaryButton={true}
        showPrimaryButton={true}
        showSecondaryButton={true}
        secondaryButtonProps={{
          text: 'Modify',
          variant: "tertiary",
          className: "modal-secondary-button modal-modify-btn",
          iconLeading: "edit",
          onClick: async () => {
            closeViewModal();
            const w = window.screen.width * .9;
            const h = window.screen.height * .9;
            const l = window.screen.width * .05;
            const t = window.screen.height * .05;
            window.open(viewReqestData?.viewWorkItemUrl, "_blank", `width=${w},height=${h},left=${l},top=${t}`);
          },
        }}
        auxiliaryButtonProps={{
          text: t("approvals.reject"),
          variant: "tertiary",
          className: "modal-secondary-button modal-deny-btn",
          iconLeading: "close",
          onClick: () => {
            closeViewModal();
            if (viewReqestData?.enableRedirection) {
              const w = window.screen.width * .9;
              const h = window.screen.height * .9;
              const l = window.screen.width * .05;
              const t = window.screen.height * .05;
              window.open(viewReqestData?.viewWorkItemUrl, "_blank", `width=${w},height=${h},left=${l},top=${t}`);
            }
            else {
              openModal('Reject', viewReqestData, 'single')
            }
          }
        }}
        primaryButtonProps={{
          text: 'Approve',
          variant: "primary",
          className: "modal-approve-btn",
          iconLeading: "check",
          onClick: async () => {
            closeViewModal();
            if (viewReqestData?.enableRedirection) {
              const w = window.screen.width * .9;
              const h = window.screen.height * .9;
              const l = window.screen.width * .05;
              const t = window.screen.height * .05;
              window.open(viewReqestData?.viewWorkItemUrl, "_blank", `width=${w},height=${h},left=${l},top=${t}`);
            }
            else {
              isRetirementApproval ? approveOrRejectAppRetirement('Approve', [viewReqestData]) : isSSOApproval ? approveOrRejectSSORequest('Approve', [viewReqestData]) : isEntraApproval ? approveOrRejectEntraRequest('Approve', [viewReqestData]) : isMyPamApproval ? approveOrRejectMyPamRequest('Approve', [viewReqestData]) : approveOrRejectRequest('Approve', [viewReqestData]);
            }
          },
        }}

        title={viewReqestData?.requestNumber ? `Request Number : ${viewReqestData?.requestNumber}` : "View Request"}
        type="fluid"



      // size="large"
      // id="viewRequestModal"
      // className={isMobile || isTab ? "mobile-view-request-modal" : ""}
      // closeOnOutsideClick
      // onCloseModal={closeViewModal}
      // showCloseButton
      // showModal={isViewModalOpen}
      // style={{}}
      // tertiaryButtonProps=""
      // auxiliaryButtonProps={{
      //   text: 'Modify',
      //   variant: "tertiary",
      //   className: "modal-secondary-button modal-modify-btn",
      //   iconLeading: "edit",
      //   onClick: async () => {
      //     closeViewModal();
      //     window.open(viewReqestData?.viewWorkItemUrl, "_blank");
      //   },
      // }}
      // secondaryButtonProps={{
      //   text: 'Deny',
      //   variant: "tertiary",
      //   className: "modal-secondary-button modal-deny-btn",
      //   iconLeading: "close",
      //   onClick: () => {
      //     closeViewModal();
      //     approveOrRejectRequest('Reject', [viewReqestData]);
      //   }
      // }}
      // primaryButtonProps={{
      //   text: 'Approve',
      //   variant: "primary",
      //   className: "modal-approve-btn",
      //   iconLeading: "check",
      //   onClick: async () => {
      //     closeViewModal();
      //     approveOrRejectRequest('Approve', [viewReqestData]);
      //   },
      // }}
      // showPrimaryButton={true}
      // showSecondaryButton={true}
      // showAuxiliaryButton={true}
      // showTertiaryButton={false}
      // // secondaryButtonProps={{
      // //   onClick: () => closeViewModal(),
      // //   size: 'medium',
      // //   text: 'Cancel',
      // //   variant: 'secondary'
      // // }}
      // // secondaryButtonProps={{
      // //   text: 'Deny',
      // //   variant: "tertiary",
      // //   onClick: () => {
      // //     closeViewModal();
      // //     approveOrRejectRequest('Reject', [viewReqestData]);
      // //   }
      // // }}
      // // primaryButtonProps={{
      // //   text: 'Approve',
      // //   variant: "primary",
      // //   onClick: async () => {
      // //     closeViewModal();
      // //     approveOrRejectRequest('Approve', [viewReqestData]);
      // //   },
      // // }}

      // title={viewReqestData?.requestNumber ? `Request Number : ${viewReqestData?.requestNumber}` : "View Request"}
      // type="fluid"

      >
        <div>
          <div className="d-flex w-100 flex-wrap" style={{ gap: "8px" }}>

            {viewReqestData?.businessDetailsParams && viewReqestData?.businessDetailsParams?.length > 0 && (
              <>
                {viewReqestData?.businessDetailsParams?.map?.((param, index) => {
                  if (!param.detailsValue) return null;
                  const isHtml = /<\/?[a-z][\s\S]*>/i.test(param.detailsValue);
                  return (
                    <div key={viewReqestData?.requestNumber + index} className="d-grid detail-pair">
                      <span className="approvalInfoLabel">{param.detailsKey}:</span>
                      {isHtml ? (
                        <span className="approvalInfoValue" dangerouslySetInnerHTML={{ __html: param.detailsValue }}></span>
                      ) : (
                        <span className="approvalInfoValue">{param.detailsValue}</span>
                      )}
                    </div>
                  );
                })}
                <hr className="custom-hr" />
                {/* <hr className="custom-hr" /> */}
                {/* 
                <div className="d-grid w-100" style={{ gap: "8px" }}>
                  <div className="approvalInfoLabel">Is this Associate moving from a Position Code that currently has a myHR-EC Security Role?</div>
                  <div className="approvalInfoValue">No</div>
                  <div className="approvalInfoLabel">Please confirm if requested myHR-EC Security Role corresponds to assignee's Job Title?</div>
                  <div className="approvalInfoValue">Yes</div>
                  <div className="approvalInfoLabel">Is the assignee backfilling an existing position?</div>
                  <div className="approvalInfoValue">Yes</div>
                </div>
                <hr className="custom-hr" />
                <div className="d-grid w-100" style={{ gap: "8px" }}>
                  <div className="approvalInfoLabel">Comments</div>
                  <div className="approvalInfoValue">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore 1  et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</div>
                </div>*/}
                {/* <div>
                  <div>Do you want to modify this data?</div>
                  <Button
                    size="small"
                    text="myidM"
                    variant="primary"
                    iconTrailing="arrow_forward"
                    onClick={() => modifyRequestData()}
                  />
                </div> */}
              </>
            )}
            {viewReqestData &&
              Object.entries(viewReqestData).map(([key, value], index) => {
                // Skip `businessDetailsParams` since it's already rendered above
                if (key === 'businessDetailsParams' || key === 'keyId' || key === 'dueStatusCode' || key === 'dueStatus' || key === 'enableRedirection' || key === 'workItemId' || key === 'viewWorkItemUrl') return null;
                if (value === null || value === undefined || value === '') return null;
                const displayValue =
                  typeof value === 'object' && value !== null
                    ? JSON.stringify(value)
                    : String(value);

                return (
                  <div key={`viewRequest_${index}`} className="d-grid detail-pair">
                    <span className="approvalInfoLabel titleCase">{formatLabel(key)}:</span>
                    <span className="approvalInfoValue">{displayValue}</span>
                  </div>
                );
              })}
          </div>
        </div>
      </Modal>
      <Modal
        size="large"
        id="viewRequestModal"
        className={isMobile || isTab ? "mobile-view-request-modal" : ""}
        closeOnOutsideClick = {false}
        onCloseModal={()=>setIsEntraViewModalOpen(false)}
        showCloseButton
        showModal={isEntraViewModalOpen}
        style={{}}
        tertiaryButtonProps=""
        showAuxiliaryButton={true}
        showPrimaryButton={true}
        showSecondaryButton={false}
        auxiliaryButtonProps={{
          text: t("approvals.reject"),
          variant: "tertiary",
          className: "modal-secondary-button modal-deny-btn",
          iconLeading: "close",
          onClick: () => {
            setIsEntraViewModalOpen(false);
            openModal('Reject', viewReqestData, 'single');
          }
        }}
        primaryButtonProps={{
          text: t("approvals.approve"),
          variant: "primary",
          className: "modal-approve-btn",
          iconLeading: "check",
          onClick: async () => {
            setIsEntraViewModalOpen(false)
            isRetirementApproval ? approveOrRejectAppRetirement('Approve', [viewReqestData]) : isEntraApproval ? approveOrRejectEntraRequest('Approve', [viewReqestData]) : isMyPamApproval ? approveOrRejectMyPamRequest('Approve', [viewReqestData]) : approveOrRejectRequest('Approve', [viewReqestData]);
          },
        }}

        title={`Req # ${viewReqestData?.requestNumber}`}
        type="fluid"
      >
        <div>
          <div className="d-flex w-100 flex-wrap" style={{ gap: "8px" }}>
            <div className="d-grid detail-pair" style={{width:"200px"}}>
              <span className="approvalInfoLabel titleCase">{t("entraGuest.requested_by_with_colon")}</span>
              <span className="approvalInfoValue">{viewReqestData?.requestedBy}</span>
            </div>
            <div className="d-grid detail-pair" style={{width:"200px"}}>
              <span className="approvalInfoLabel titleCase">{t("entraGuest.user_name_with_colon")}</span>
              <span className="approvalInfoValue">{viewReqestData?.requestedByUserName}</span>
            </div>
          </div>
          {viewReqestData?.requestType === 'Entra App Registration' ?
              <div className="d-flex w-100 flex-wrap" style={{ gap: "8px" }}>
                {viewReqestData?.displayFields &&
              Object.entries(viewReqestData?.displayFields).map(([key, value], index) => {
                if (value === null || value === undefined || value === '') return null;
                const displayValue =
                  typeof value === 'object' && value !== null
                    ? JSON.stringify(value)
                    : String(value);

                return (
                  <div key={`viewRequest_${index}`} className="d-grid detail-pair">
                    <span className="approvalInfoLabel titleCase">{formatLabel(key)}:</span>
                    <span className="approvalInfoValue">{key==="API Permissions" ? (
                      () => {
                        try {
                          const permissions = JSON.parse(displayValue);
                          return permissions.map(p => p.name).join(", ");
                        } catch {
                          return displayValue;
                        }
                      }
                    )() : displayValue?.replace?.(/^\[|\}|\{|\"|\]$/g, "")}</span>
                  </div>
                );
              })}
              </div>
              :
              <>
                <div className="mb-2 mt-3" style={{fontSize: "14px", fontWeight: "600", color: "#2D2D2D"}}>
                  {t("entraGuest.guest_details")}
                </div>
                {
                  (viewReqestData?.requestType === 'BULK' && viewReqestData?.fileName) ? 
                  <div className="view-Request-Bulk-File-name d-flex justify-content-between">
                    <div className="file-name d-flex">
                      <Icon icon="insert_drive_file" size="medium" style={{ color: '#3a3a3a' }} />
                      <div className="ml-2">{viewReqestData?.fileName}</div>
                    </div>
                    <Icon onClick={()=> viewReqestData?.downloadEnabled && downloadBulkfile(viewReqestData?.requestNumber, viewReqestData?.fileName)} icon="download" size="medium" style={{ color: '#004895', cursor: 'pointer', ...(!viewReqestData?.downloadEnabled && {cursor: 'not-allowed', opacity: '0.5'}) }} />
                  </div>
                  :
                  <DataTable
                      className="datatable"
                      columns={guestUsersDetailsColumns}
                      key={i18n.language}
                      enableSorting={true}
                      data={viewReqestData?.guestUsers || []}
                      pageIndex={0}
                      pageSize={10}
                      selection="single"
                      tableHeader=""
                      size="large"
                      showTableHeader={true}
                      showTitle={true}
                      showSearchOption={false}
                      showColumnFilters={false}
                      showDescription={false}
                      tableDescription=""
                      showPagination={false}
                      noDataDescriptionText=""
                  />
                }
              </>
          }
        </div>
      </Modal>
      <Modal
        size="large"
        id="viewRequestModal"
        className={isMobile || isTab ? "mobile-view-request-modal" : ""}
        closeOnOutsideClick = {false}
        onCloseModal={()=>setIsMyPamViewModalOpen(false)}
        showCloseButton
        showModal={isMyPamViewModalOpen}
        style={{}}
        tertiaryButtonProps=""
        showAuxiliaryButton={true}
        showPrimaryButton={true}
        showSecondaryButton={false}
        auxiliaryButtonProps={{
          text: t("approvals.reject"),
          variant: "tertiary",
          className: "modal-secondary-button modal-deny-btn",
          iconLeading: "close",
          onClick: () => {
            setIsMyPamViewModalOpen(false);
            openModal('Reject', viewReqestData, 'single');
          }
        }}
        primaryButtonProps={{
          text: t("approvals.approve"),
          variant: "primary",
          className: "modal-approve-btn",
          iconLeading: "check",
          onClick: async () => {
            setIsMyPamViewModalOpen(false)
            approveOrRejectMyPamRequest('Approve', [viewReqestData]);
          },
        }}

        title={`Req # ${viewReqestData?.requestNumber}`}
        type="fluid"
      >
        <div>
          <div className="d-flex w-100 flex-wrap" style={{ gap: "8px" }}>
            <div className="d-grid detail-pair" style={{width:"48%"}}>
              <span className="approvalInfoLabel titleCase">{t("auditRequest.status")}</span>
              <span className="approvalInfoValue">{viewReqestData?.status}</span>
            </div>
            <div className="d-grid detail-pair" style={{width:"48%"}}>
              <span className="approvalInfoLabel titleCase">{t("auditRequest.approver_gpid_label")}</span>
              <span className="approvalInfoValue">{viewReqestData?.approverGpid}</span>
            </div>
            {
            Object.entries(myPamViewMoreData)?.map?.(([key, val])=> (
            (Array.isArray(val) ? val?.length > 0 : val) ? ((key !== "requestNumber" && key !== "keyId" && key !== "dueStatusCode" && key !== "dueStatus" && key !== "status") && <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">{camelToTitle(key)}</span>
                <span className="approvalInfoValue">{Array.isArray(val) ? val.join(", ") : val}</span>
              </div>) : null
            ))
            }
            {/* {
              viewReqestData?.safeName && <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">{t("mypam.safe_name")}</span>
                <span className="approvalInfoValue">{viewReqestData?.safeName}</span>
              </div>
            }
            {
              viewReqestData?.addMembers?.length > 0 && <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">{t("mypam.add_members")}</span>
                <span className="approvalInfoValue">{viewReqestData?.addMembers.join(", ")}</span>
              </div>
            }
            {
              viewReqestData?.removeMembers?.length > 0 && <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">{t("mypam.remove_members")}</span>
                <span className="approvalInfoValue">{viewReqestData?.removeMembers.join(", ")}</span>
              </div>
            }
            {
              viewReqestData?.safeNames?.length > 0 && <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">{t("mypam.safe_names")}</span>
                <span className="approvalInfoValue">{viewReqestData?.safeNames.join(", ")}</span>
              </div>
            }
            {
              viewReqestData?.businessJustification && <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">{t("mypam.business_justification")}</span>
                <span className="approvalInfoValue">{viewReqestData?.businessJustification}</span>
              </div>
            } */}
          </div>
        </div>
      </Modal>
      <Modal
        size="large"
        id="viewRequestModal"
        className={isMobile || isTab ? "mobile-view-request-modal" : ""}
        closeOnOutsideClick = {false}
        onCloseModal={()=>setIsRetirementViewModalOpen(false)}
        showCloseButton
        showModal={isRetirementViewModalOpen}
        style={{}}
        tertiaryButtonProps=""
        showAuxiliaryButton={true}
        showPrimaryButton={true}
        showSecondaryButton={false}
        auxiliaryButtonProps={{
          text: t("approvals.reject"),
          variant: "tertiary",
          className: "modal-secondary-button modal-deny-btn",
          iconLeading: "close",
          onClick: () => {
            setIsRetirementViewModalOpen(false);
            openModal('Reject', viewReqestData, 'single');
          }
        }}
        primaryButtonProps={{
          text: t("approvals.approve"),
          variant: "primary",
          className: "modal-approve-btn",
          iconLeading: "check",
          onClick: async () => {
            setIsRetirementViewModalOpen(false)
            approveOrRejectAppRetirement('Approve', [viewReqestData]);
          },
        }}

        title={`Req # ${viewReqestData?.requestNumber}`}
        type="fluid"
      >
        <div>
          <div className="d-flex w-100 flex-wrap" style={{ gap: "8px" }}>
            {
            Object.entries(retirementViewMoreData)?.map?.(([key, val])=> (
            (Array.isArray(val) ? val?.length > 0 : val) ? ((key !== "requestNumber" && key !== "keyId" && key !== "dueStatusCode" && key !== "dueStatus" && key !== "status" && key !== "taskId") && <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">{camelToTitle(key)}</span>
                <span className="approvalInfoValue">{Array.isArray(val) ? val.join(", ") : val}</span>
              </div>) : null
            ))
            }
          </div>
        </div>
      </Modal>
      <Modal
        size="large"
        id="ssoViewRequestModal"
        className={isMobile || isTab ? "mobile-view-request-modal" : ""}
        closeOnOutsideClick = {false}
        onCloseModal={()=>setIsSSOViewModalOpen(false)}
        showCloseButton
        showModal={isSSOViewModalOpen}
        style={{}}
        tertiaryButtonProps=""
        showAuxiliaryButton={true}
        showPrimaryButton={true}
        showSecondaryButton={false}
        auxiliaryButtonProps={{
          text: t("approvals.reject"),
          variant: "tertiary",
          className: "modal-secondary-button modal-deny-btn",
          iconLeading: "close",
          onClick: () => {
            setIsSSOViewModalOpen(false);
            openModal('Reject', viewReqestData, 'single');
          }
        }}
        primaryButtonProps={{
          text: t("approvals.approve"),
          variant: "primary",
          className: "modal-approve-btn",
          iconLeading: "check",
          onClick: async () => {
            setIsSSOViewModalOpen(false)
            approveOrRejectSSORequest('Approve', [viewReqestData]);
          },
        }}

        title={`SSO Request # ${viewReqestData?.requestNumber}`}
        type="fluid"
      >
        <div>
          <div className="d-flex w-100 flex-wrap" style={{ gap: "8px" }}>
            {viewReqestData?.requestNumber && (
              <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">Request Number</span>
                <span className="approvalInfoValue">{viewReqestData?.requestNumber}</span>
              </div>
            )}
            {viewReqestData?.taskName && (
              <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">Approval Step</span>
                <span className="approvalInfoValue">{viewReqestData?.taskName}</span>
              </div>
            )}
            {viewReqestData?.requestedBy && (
              <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">Requestor (GPID)</span>
                <span className="approvalInfoValue">{viewReqestData?.requestedBy}</span>
              </div>
            )}
            {viewReqestData?.requestedByUserName && (
              <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">Requestor (Name)</span>
                <span className="approvalInfoValue">{viewReqestData?.requestedByUserName}</span>
              </div>
            )}
            {/* Business Information */}
            {(ssoViewMoreData?.['Integration Type'] || ssoViewMoreData?.integrationType || ssoViewMoreData?.type) && (
              <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">Integration Type</span>
                <span className="approvalInfoValue">{ssoViewMoreData?.['Integration Type'] || ssoViewMoreData?.integrationType || ssoViewMoreData?.type}</span>
              </div>
            )}
            {(ssoViewMoreData?.['Sector'] || ssoViewMoreData?.sector) && (
              <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">Sector</span>
                <span className="approvalInfoValue">{ssoViewMoreData?.['Sector'] || ssoViewMoreData?.sector}</span>
              </div>
            )}
            {(ssoViewMoreData?.['Environment'] || ssoViewMoreData?.environment) && (
              <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">Environment</span>
                <span className="approvalInfoValue">{ssoViewMoreData?.['Environment'] || ssoViewMoreData?.environment}</span>
              </div>
            )}
            {(ssoViewMoreData?.['Business Application'] || ssoViewMoreData?.businessAppName || ssoViewMoreData?.businessApplication) && (
              <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">Business Application</span>
                <span className="approvalInfoValue">{ssoViewMoreData?.['Business Application'] || ssoViewMoreData?.businessAppName || ssoViewMoreData?.businessApplication}</span>
              </div>
            )}
            {(ssoViewMoreData?.['Application Service'] || ssoViewMoreData?.applicationService) && (
              <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">Application Service</span>
                <span className="approvalInfoValue">{ssoViewMoreData?.['Application Service'] || ssoViewMoreData?.applicationService}</span>
              </div>
            )}
            {(ssoViewMoreData?.['Data Classification'] || ssoViewMoreData?.dataClassification) && (
              <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">Data Classification</span>
                <span className="approvalInfoValue">{ssoViewMoreData?.['Data Classification'] || ssoViewMoreData?.dataClassification}</span>
              </div>
            )}
            {(ssoViewMoreData?.['Application Owner'] || ssoViewMoreData?.applicationOwner) && (
              <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">Application Owner</span>
                <span className="approvalInfoValue">{ssoViewMoreData?.['Application Owner'] || ssoViewMoreData?.applicationOwner}</span>
              </div>
            )}

            {/* Application Details - Common */}
            {(ssoViewMoreData?.['Application Name'] || ssoViewMoreData?.applicationName) && (
              <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">Application Name</span>
                <span className="approvalInfoValue">{ssoViewMoreData?.['Application Name'] || ssoViewMoreData?.applicationName}</span>
              </div>
            )}

            {/* SAML specific fields */}
            {(ssoViewMoreData?.['Integration Type']?.includes?.('SAML') || ssoViewMoreData?.integrationType?.includes?.('SAML') || ssoViewMoreData?.type === 'SAML') && (
              <>
                {(ssoViewMoreData?.['Application URL'] || ssoViewMoreData?.applicationURL || ssoViewMoreData?.applicationUrl) && (
                  <div className="d-grid detail-pair" style={{width:"48%"}}>
                    <span className="approvalInfoLabel titleCase">End-user Application URL</span>
                    <span className="approvalInfoValue" style={{wordBreak: 'break-all'}}>{ssoViewMoreData?.['Application URL'] || ssoViewMoreData?.applicationURL || ssoViewMoreData?.applicationUrl}</span>
                  </div>
                )}
                {(ssoViewMoreData?.['Assertion Consumer Service (ACS) URL'] || ssoViewMoreData?.acsURL) && (
                  <div className="d-grid detail-pair" style={{width:"48%"}}>
                    <span className="approvalInfoLabel titleCase">Assertion Consumer Service (ACS) URL</span>
                    <span className="approvalInfoValue" style={{wordBreak: 'break-all'}}>{ssoViewMoreData?.['Assertion Consumer Service (ACS) URL'] || ssoViewMoreData?.acsURL}</span>
                  </div>
                )}
                {(ssoViewMoreData?.['Audience URI (SP Entity ID)'] || ssoViewMoreData?.entityID) && (
                  <div className="d-grid detail-pair" style={{width:"48%"}}>
                    <span className="approvalInfoLabel titleCase">Audience URI (SP Entity ID)</span>
                    <span className="approvalInfoValue" style={{wordBreak: 'break-all'}}>{ssoViewMoreData?.['Audience URI (SP Entity ID)'] || ssoViewMoreData?.entityID}</span>
                  </div>
                )}
                {(ssoViewMoreData?.['Name ID Format'] || ssoViewMoreData?.nameIdFormat || ssoViewMoreData?.nameIdFormatType) && (
                  <div className="d-grid detail-pair" style={{width:"48%"}}>
                    <span className="approvalInfoLabel titleCase">Name ID Format</span>
                    <span className="approvalInfoValue">{ssoViewMoreData?.nameIdFormatType || ssoViewMoreData?.['Name ID Format'] || ssoViewMoreData?.nameIdFormat}</span>
                  </div>
                )}
                {(ssoViewMoreData?.['Application Short Name'] || ssoViewMoreData?.applicationShortName) && (
                  <div className="d-grid detail-pair" style={{width:"48%"}}>
                    <span className="approvalInfoLabel titleCase">Application Short Name</span>
                    <span className="approvalInfoValue">{ssoViewMoreData?.['Application Short Name'] || ssoViewMoreData?.applicationShortName}</span>
                  </div>
                )}
                {(ssoViewMoreData?.['Application Access Control'] || ssoViewMoreData?.accessControls) && (
                  <div className="d-grid detail-pair" style={{width:"48%"}}>
                    <span className="approvalInfoLabel titleCase">Application Access Control</span>
                    <span className="approvalInfoValue">{Array.isArray(ssoViewMoreData?.accessControls) ? ssoViewMoreData.accessControls.join(', ') : (ssoViewMoreData?.['Application Access Control'] || ssoViewMoreData?.accessControls)}</span>
                  </div>
                )}
                {(getSsoFieldValue(
                  ssoViewMoreData,
                  'Is Admin App',
                  'Elevated Permissions',
                  'Is application designed for administrators with elevated permissions, with restricted access for standard users ?',
                  'Is application designed for administrators with elevated permissions, with restricted access for standard users?',
                  'isAdminApp'
                ) !== undefined) && (
                  <div className="d-grid detail-pair" style={{width:"48%"}}>
                    <span className="approvalInfoLabel titleCase">Is application designed for administrators with elevated permissions, with restricted access for standard users ?</span>
                    <span className="approvalInfoValue">{isYesValue(getSsoFieldValue(
                      ssoViewMoreData,
                      'Is Admin App',
                      'Elevated Permissions',
                      'Is application designed for administrators with elevated permissions, with restricted access for standard users ?',
                      'Is application designed for administrators with elevated permissions, with restricted access for standard users?',
                      'isAdminApp'
                    )) ? 'Yes' : 'No'}</span>
                  </div>
                )}
              </>
            )}

            {/* OIDC specific fields */}
            {(ssoViewMoreData?.['Integration Type']?.includes?.('OIDC') || ssoViewMoreData?.integrationType?.includes?.('OIDC') || ssoViewMoreData?.type === 'OIDC') && (
              <>
                {(ssoViewMoreData?.['Application Type'] || ssoViewMoreData?.applicationType || ssoViewMoreData?.applicationTypeName) && (
                  <div className="d-grid detail-pair" style={{width:"48%"}}>
                    <span className="approvalInfoLabel titleCase">Application Type</span>
                    <span className="approvalInfoValue">{ssoViewMoreData?.applicationTypeName || ssoViewMoreData?.['Application Type'] || ssoViewMoreData?.applicationType}</span>
                  </div>
                )}
                {(ssoViewMoreData?.['Application URL'] || ssoViewMoreData?.applicationURL || ssoViewMoreData?.applicationUrl) && (
                  <div className="d-grid detail-pair" style={{width:"48%"}}>
                    <span className="approvalInfoLabel titleCase">Application URL</span>
                    <span className="approvalInfoValue" style={{wordBreak: 'break-all'}}>{ssoViewMoreData?.['Application URL'] || ssoViewMoreData?.applicationURL || ssoViewMoreData?.applicationUrl}</span>
                  </div>
                )}
                {(ssoViewMoreData?.['Application Short Name'] || ssoViewMoreData?.applicationShortName) && (
                  <div className="d-grid detail-pair" style={{width:"48%"}}>
                    <span className="approvalInfoLabel titleCase">Application Short Name</span>
                    <span className="approvalInfoValue">{ssoViewMoreData?.['Application Short Name'] || ssoViewMoreData?.applicationShortName}</span>
                  </div>
                )}
                {(ssoViewMoreData?.['Login URL'] || ssoViewMoreData?.['Sign-in Redirect URIs'] || ssoViewMoreData?.signinUris) && (
                  <div className="d-grid detail-pair" style={{width:"48%"}}>
                    <span className="approvalInfoLabel titleCase">Login URL / Sign-in Redirect URIs</span>
                    <span className="approvalInfoValue" style={{wordBreak: 'break-all'}}>{ssoViewMoreData?.['Login URL'] || (Array.isArray(ssoViewMoreData?.signinUris) ? ssoViewMoreData.signinUris.join(', ') : (ssoViewMoreData?.['Sign-in Redirect URIs'] || ssoViewMoreData?.signinUris))}</span>
                  </div>
                )}
                {(ssoViewMoreData?.['Logout URL'] || ssoViewMoreData?.['Sign-out Redirect URIs'] || ssoViewMoreData?.signoutUris) && (
                  <div className="d-grid detail-pair" style={{width:"48%"}}>
                    <span className="approvalInfoLabel titleCase">Logout URL / Sign-out Redirect URIs</span>
                    <span className="approvalInfoValue" style={{wordBreak: 'break-all'}}>{ssoViewMoreData?.['Logout URL'] || (Array.isArray(ssoViewMoreData?.signoutUris) ? ssoViewMoreData.signoutUris.join(', ') : (ssoViewMoreData?.['Sign-out Redirect URIs'] || ssoViewMoreData?.signoutUris))}</span>
                  </div>
                )}
                {(ssoViewMoreData?.['Grants'] || ssoViewMoreData?.grants) && (
                  <div className="d-grid detail-pair" style={{width:"48%"}}>
                    <span className="approvalInfoLabel titleCase">Grants</span>
                    <span className="approvalInfoValue">{Array.isArray(ssoViewMoreData?.grants) ? ssoViewMoreData.grants.join(', ') : (ssoViewMoreData?.['Grants'] || ssoViewMoreData?.grants)}</span>
                  </div>
                )}
                {(ssoViewMoreData?.['Application Access Control'] || ssoViewMoreData?.accessControls) && (
                  <div className="d-grid detail-pair" style={{width:"48%"}}>
                    <span className="approvalInfoLabel titleCase">Application Access Control</span>
                    <span className="approvalInfoValue">{Array.isArray(ssoViewMoreData?.accessControls) ? ssoViewMoreData.accessControls.join(', ') : (ssoViewMoreData?.['Application Access Control'] || ssoViewMoreData?.accessControls)}</span>
                  </div>
                )}
                {(getSsoFieldValue(
                  ssoViewMoreData,
                  'Is Admin App',
                  'Elevated Permissions',
                  'Is application designed for administrators with elevated permissions, with restricted access for standard users ?',
                  'Is application designed for administrators with elevated permissions, with restricted access for standard users?',
                  'isAdminApp'
                ) !== undefined) && (
                  <div className="d-grid detail-pair" style={{width:"48%"}}>
                    <span className="approvalInfoLabel titleCase">Is application designed for administrators with elevated permissions, with restricted access for standard users ?</span>
                    <span className="approvalInfoValue">{isYesValue(getSsoFieldValue(
                      ssoViewMoreData,
                      'Is Admin App',
                      'Elevated Permissions',
                      'Is application designed for administrators with elevated permissions, with restricted access for standard users ?',
                      'Is application designed for administrators with elevated permissions, with restricted access for standard users?',
                      'isAdminApp'
                    )) ? 'Yes' : 'No'}</span>
                  </div>
                )}
              </>
            )}

            {/* M2M specific fields */}
            {(ssoViewMoreData?.['Integration Type']?.includes?.('M2M') || ssoViewMoreData?.integrationType?.includes?.('M2M') || ssoViewMoreData?.type === 'M2M') && (
              <>
                {(ssoViewMoreData?.['Access Type'] || ssoViewMoreData?.accessType) && (
                  <div className="d-grid detail-pair" style={{width:"48%"}}>
                    <span className="approvalInfoLabel titleCase">Application/Services Type</span>
                    <span className="approvalInfoValue">{ssoViewMoreData?.['Access Type'] || ssoViewMoreData?.accessType}</span>
                  </div>
                )}
                {(ssoViewMoreData?.['Scopes'] || ssoViewMoreData?.scopes) && (
                  <div className="d-grid detail-pair" style={{width:"48%"}}>
                    <span className="approvalInfoLabel titleCase">Custom Scopes</span>
                    <span className="approvalInfoValue">{Array.isArray(ssoViewMoreData?.scopes) ? ssoViewMoreData.scopes.join(', ') : (ssoViewMoreData?.['Scopes'] || ssoViewMoreData?.scopes)}</span>
                  </div>
                )}
                {(ssoViewMoreData?.['Grants'] || ssoViewMoreData?.grants) && (
                  <div className="d-grid detail-pair" style={{width:"48%"}}>
                    <span className="approvalInfoLabel titleCase">Grants</span>
                    <span className="approvalInfoValue">{Array.isArray(ssoViewMoreData?.grants) ? ssoViewMoreData.grants.join(', ') : (ssoViewMoreData?.['Grants'] || ssoViewMoreData?.grants)}</span>
                  </div>
                )}
              </>
            )}

            {!!ssoViewMoreData?.tokenValidation && (
              <div
                className="d-grid detail-pair"
                style={{
                  width: '100%',
                  gap: '10px',
                  marginTop: '12px',
                  padding: '16px',
                  borderRadius: '10px',
                  backgroundColor: '#f5f6f8'
                }}
              >
                <span className="approvalInfoLabel titleCase" style={{ fontSize: '18px', fontWeight: 700, color: '#2d2d2d', marginBottom: '2px' }}>
                  Machine2Machine Token Validation Details
                </span>

                <div className="d-flex align-items-center" style={{ gap: '8px', flexWrap: 'wrap' }}>
                  <span className="approvalInfoLabel titleCase" style={{ marginBottom: 0, fontWeight: 700, color: '#4b4b4b' }}>Status:</span>
                  <span
                    style={{
                      ...getTokenBadgeStyles(getTokenValidationStatusColor(ssoViewMoreData?.tokenValidation?.status)),
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      minHeight: '24px',
                      padding: '2px 8px',
                      borderRadius: '4px',
                      fontSize: '12px',
                      fontWeight: 600,
                      lineHeight: '18px'
                    }}
                  >
                    {getTokenValidationStatusText(ssoViewMoreData?.tokenValidation?.status)}
                  </span>
                </div>

                {ssoViewMoreData?.tokenValidation?.message && (
                  <div className="approvalInfoValue" style={{ color: '#616161', fontSize: '14px' }}>{ssoViewMoreData?.tokenValidation?.message}</div>
                )}

                {Array.isArray(ssoViewMoreData?.tokenValidation?.data) && ssoViewMoreData?.tokenValidation?.data?.length > 0 && (
                  <div style={{ overflowX: 'auto', border: '1px solid #d8e2f1', borderRadius: '8px', backgroundColor: '#fff' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                      <thead>
                        <tr style={{ backgroundColor: '#eef4fd' }}>
                          <th style={{ textAlign: 'left', padding: '12px 16px', borderBottom: '1px solid #d8e2f1', fontSize: '13px', fontWeight: 700, color: '#4b4b4b' }}>DATE</th>
                          <th style={{ textAlign: 'left', padding: '12px 16px', borderBottom: '1px solid #d8e2f1', fontSize: '13px', fontWeight: 700, color: '#4b4b4b' }}>COUNT</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ssoViewMoreData?.tokenValidation?.data?.map((item, idx) => (
                          <tr key={`${item?.date || 'na'}-${idx}`}>
                            <td style={{ padding: '12px 16px', borderBottom: '1px solid #e9eef8', fontSize: '14px', color: '#4b4b4b' }}>{item?.date || '-'}</td>
                            <td style={{ padding: '12px 16px', borderBottom: '1px solid #e9eef8', fontSize: '14px', color: '#4b4b4b' }}>{item?.count ?? '-'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                <div className="d-flex align-items-center" style={{ gap: '8px', flexWrap: 'wrap' }}>
                  <span className="approvalInfoLabel titleCase" style={{ marginBottom: 0, fontWeight: 700, color: '#2d2d2d' }}>Automated Decision:</span>
                  <span
                    style={{
                      ...getTokenBadgeStyles(getAutomatedDecisionColor(ssoViewMoreData?.tokenValidation)),
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      minHeight: '24px',
                      padding: '2px 8px',
                      borderRadius: '4px',
                      fontSize: '12px',
                      fontWeight: 600,
                      lineHeight: '18px'
                    }}
                  >
                    {getAutomatedDecisionFromTokenStatus(ssoViewMoreData?.tokenValidation)}
                  </span>
                </div>

                {(ssoViewMoreData?.tokenValidation?.meta?.nextSteps || ssoViewMoreData?.tokenValidation?.message) && (
                  <div className="approvalInfoValue" style={{ color: '#616161', fontSize: '14px' }}>
                    {ssoViewMoreData?.tokenValidation?.meta?.nextSteps || ssoViewMoreData?.tokenValidation?.message}
                  </div>
                )}
              </div>
            )}

            {/* IDX Attribute - for SAML and OIDC */}
            {(getSsoFieldValue(ssoViewMoreData, 'IDX Attribute Name', 'idxAttribute', 'idx_attribute', 'IDX Attribute') !== undefined) && (
              <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">IDX Attribute Name</span>
                <span className="approvalInfoValue">{getSsoFieldValue(ssoViewMoreData, 'IDX Attribute Name', 'idxAttribute', 'idx_attribute', 'IDX Attribute')}</span>
              </div>
            )}

            {(getSsoFieldValue(ssoViewMoreData, 'Is New IDX Attribute', 'newIdxAttribute', 'New IDX Attribute', 'isNewIdxAttribute', 'is_new_idx_attribute') !== undefined) && (
              <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">Is New IDX Attribute</span>
                <span className="approvalInfoValue">{isYesValue(getSsoFieldValue(ssoViewMoreData, 'Is New IDX Attribute', 'newIdxAttribute', 'New IDX Attribute', 'isNewIdxAttribute', 'is_new_idx_attribute')) ? 'Yes' : 'No'}</span>
              </div>
            )}

            {/* Roles - for SAML */}
            {(ssoViewMoreData?.['Roles'] || ssoViewMoreData?.roles) && (
              <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">Authorization Roles</span>
                <span className="approvalInfoValue">{Array.isArray(ssoViewMoreData?.roles) ? ssoViewMoreData.roles.join(', ') : (ssoViewMoreData?.['Roles'] || ssoViewMoreData?.roles)}</span>
              </div>
            )}

            {/* Role IDX Attribute - for SAML */}
            {(getSsoFieldValue(ssoViewMoreData, 'Role IDX Attribute', 'Role Idx Attribute', 'roleIdxAttribute', 'role_idx_attribute') !== undefined) && (
              <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">Role Idx Attribute</span>
                <span className="approvalInfoValue">{getSsoFieldValue(ssoViewMoreData, 'Role IDX Attribute', 'Role Idx Attribute', 'roleIdxAttribute', 'role_idx_attribute')}</span>
              </div>
            )}

            {(getSsoFieldValue(ssoViewMoreData, 'Is New Role IDX Attribute', 'newRoleIdxAttribute', 'New Role IDX Attribute', 'isNewRoleIdxAttribute', 'is_new_role_idx_attribute') !== undefined) && (
              <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">Is New Role IDX Attribute</span>
                <span className="approvalInfoValue">{isYesValue(getSsoFieldValue(ssoViewMoreData, 'Is New Role IDX Attribute', 'newRoleIdxAttribute', 'New Role IDX Attribute', 'isNewRoleIdxAttribute', 'is_new_role_idx_attribute')) ? 'Yes' : 'No'}</span>
              </div>
            )}

            {/* Comments */}
            {(ssoViewMoreData?.['Comments'] || ssoViewMoreData?.comments) && (
              <div className="d-grid detail-pair" style={{width:"100%"}}>
                <span className="approvalInfoLabel titleCase">Comments</span>
                <span className="approvalInfoValue">{ssoViewMoreData?.['Comments'] || ssoViewMoreData?.comments}</span>
              </div>
            )}
            {/* Disclaimer Acknowledged */}
            {/* {(ssoViewMoreData?.['Disclaimer Acknowledged'] || ssoViewMoreData?.disclaimerAccepted !== undefined) && (
              <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">Disclaimer Acknowledged</span>
                <span className="approvalInfoValue">{ssoViewMoreData?.['Disclaimer Acknowledged'] === 'Yes' || ssoViewMoreData?.disclaimerAccepted === true ? 'Yes' : 'No'}</span>
              </div>
            )} */}
            {/* Has Logo */}
            {hasSsoLogoData && (
              <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">Has Logo</span>
                <span className="approvalInfoValue">Yes</span>
              </div>
            )}
            {/* Application Logo */}
            {hasSsoLogoData && (
              <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">Application Logo {ssoViewMoreData?.logoFileName && `(${ssoViewMoreData.logoFileName})`}</span>
                <div style={{ 
                  width: '120px', 
                  height: '120px', 
                  border: '1px solid #e5e7eb', 
                  borderRadius: '8px', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  overflow: 'hidden',
                  backgroundColor: '#f9fafb',
                  marginTop: '8px'
                }}>
                  {(ssoLogoUrl || ssoViewMoreData?.logoUrl) ? (
                    <img 
                      src={ssoLogoUrl || ssoViewMoreData?.logoUrl}
                      alt="Application Logo"
                      style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', cursor: 'zoom-in' }}
                      title="Click to enlarge"
                      onClick={() => openSSOLogoPreview(ssoLogoUrl || ssoViewMoreData?.logoUrl)}
                      onError={(e) => { e.target.onerror = null; e.target.src = ''; e.target.alt = 'Logo not available'; }}
                    />
                  ) : (
                    <span style={{ fontSize: '12px', color: '#999' }}>Loading...</span>
                  )}
                </div>
              </div>
            )}
            {/* Has Certificate */}
            {hasSsoCertificateData && (ssoViewMoreData?.['Integration Type']?.includes?.('SAML') || ssoViewMoreData?.type === 'SAML') && (
              <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">Has Certificate</span>
                <span className="approvalInfoValue">Yes</span>
              </div>
            )}
            {/* Certificate */}
            {hasSsoCertificateData && (
              <div className="d-grid detail-pair" style={{width:"48%"}}>
                <span className="approvalInfoLabel titleCase">Certificate</span>
                {ssoCertificateUrl ? (
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '8px',
                    padding: '8px 12px',
                    backgroundColor: '#f9fafb',
                    borderRadius: '6px',
                    border: '1px solid #e5e7eb',
                    width: 'fit-content',
                    marginTop: '8px'
                  }}>
                    <Icon icon="description" size="small" style={{ color: '#004895' }} />
                    <span style={{ fontSize: '14px', fontWeight: 500, color: '#1a1a1a' }}>
                      {ssoCertificateName || ssoViewMoreData?.['Certificate File Name'] || 'Certificate.crt'}
                    </span>
                    <a 
                      href={ssoCertificateUrl}
                      download={ssoCertificateName || ssoViewMoreData?.['Certificate File Name'] || 'Certificate.crt'}
                      style={{ 
                        display: 'flex', 
                        alignItems: 'center',
                        cursor: 'pointer',
                        color: '#004895',
                        textDecoration: 'none'
                      }}
                      title="Download Certificate"
                    >
                      <Icon icon="download" size="small" style={{ color: '#004895' }} />
                    </a>
                  </div>
                ) : (
                  <span style={{ fontSize: '12px', color: '#999', marginTop: '8px' }}>Loading...</span>
                )}
              </div>
            )}
          </div>
        </div>
      </Modal>
      <Modal
        id="ssoLogoPreviewModal"
        closeOnOutsideClick = {false}
        onCloseModal={closeSSOLogoPreview}
        showCloseButton
        showModal={isSSOLogoPreviewOpen}
        showAuxiliaryButton={false}
        showPrimaryButton={false}
        showSecondaryButton={false}
        showTertiaryButton={false}
        showLink={false}
        showSlot
        title="Application Logo"
        type="fluid"
      >
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '320px', padding: '8px' }}>
          {ssoLogoPreviewSrc ? (
            <img
              src={ssoLogoPreviewSrc}
              alt="Application Logo Preview"
              style={{ maxWidth: '90vw', maxHeight: '75vh', objectFit: 'contain', borderRadius: '8px' }}
            />
          ) : (
            <span style={{ fontSize: '12px', color: '#999' }}>Logo not available</span>
          )}
        </div>
      </Modal>
      <ToastContainer
        position="bottom-center"
        data={toasts}
        removeToast={removeToast}
      />
    </div>
    
  );

};
export default PendingApprovals_Old;
